import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MiscService } from 'app/services/misc.service';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  public pageTitle: String;
  public pageContents: Array<Object>;
  public pageHeroBackground: String;
  public pageTitleEN: String;
  public pageContentsEN: Array<Object>;
  public backgroundGradient: string;
  public FinnishSelected = false;

  constructor(
    private router: Router,
    private miscService: MiscService,
  ) {
    this.FinnishSelected = this.miscService.getLanguage();
    this.miscService.languageChange.subscribe((value) => {
      this.FinnishSelected = value;
    });
    const currentUrl = this.router.url.substr(1, this.router.url.length);

    switch (currentUrl) {
      case 'mita-ovat-energiatehokkuussopimukset':
        this.backgroundGradient = 'linear-gradient(#2b3d4f, #3497db)';
        this.pageTitle = 'Mitä ovat energiatehokkuussopimukset?';
        this.pageContents =
        [
          {
            list: [
              'Vapaaehtoinen sopimusmenettely, joka kattoi elinkeinoelämän, kunta- ja kiinteistöalan sekä öljyalan.',
              'Tavoitteena energian tarkoituksenmukainen käyttö.',
              'Mukaan liittyvä yritys tai kunta sitoutui sopimuksen mukaiseen energiatehokkuustavoitteeseen.',
              'Keino toimeenpanna EU:n energiatehokkuusvelvoitteita ja seurata niiden tavoitteiden saavuttamista Suomessa.',
              'Vaihtoehto ja täydentävä keino määräyksille.',
              'Mahdollisti valtion tuen yritysten ja kuntien tavanomaisen tekniikan energiatehokkuusinvestointeihin.'
            ],
          },
          {
            paragraph: 'Vuosina 2008–2016 energiatehokkuussopimuksissa oli mukana laajasti elinkeinoelämä, kunta-ala, kiinteistöala ja öljyala. Vuoden 2016 lopussa sopimukset kattoivat yli 65 prosenttia Suomen kokonaisenergiankäytöstä (371 TWh, 2016).'
          },
          {
            title: 'Keskeinen osa Suomen energiapolitiikkaa',
            paragraph: 'Sopimustoiminnalla on ollut Suomessa keskeinen rooli kansallisissa energia- ja ilmastostrategioissa ja EU:n energiatehokkuusvelvoitteiden ja kansainvälisten ilmastositoumusten toimeenpanossa jo vuodesta 1997 lähtien. Energiatehokkuussopimukset ovat merkittävin keino saavuttaa EU:n energiatehokkuusdirektiivin (2012/27/EU) edellyttämä Suomen sitova energiansäästövelvoite.'
          },
          {
            image: '../../assets/images/ETS-taulukko-10.svg',
            backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
          },
          {
            title: 'Välttämätön energiatehokkuus',
            paragraph: 'Energian tehokas käyttö on vastuullista ja yksi tärkeimmistä keinoista torjua ilmastonmuutosta. Energiatehokkuuden parantuminen on maailmanlaajuisesti tunnustettu välttämätön ja ensisijainen keino ”first fuel”, kun tavoitteena on energiankäytön ja kasvihuonekaasupäästöjen vähentäminen.'
          }
        ];
        this.pageTitleEN = 'Energy efficiency agreements 2008–2016';
        this.pageContentsEN =
          [
            {
              list: [
                'Voluntary Agreement Scheme covered industrial, municipal, property and building as well as oil sectors.',
                'Efficient use of energy as a main objective.',
                'Participating companies and municipalities committed to agreed energy efficiency targets.',
                'A way to implement EU energy efficiency obligations and follow-up on progress in fulfilling them in Finland.',
                'Alternative and complementary measure to regulations.',
                'A possibility for companies and municipalities to get government investment subsidies for conventional energy efficiency measures.'
              ],
            },
            {
              paragraph: 'During 2008-2016, the industrial, municipal, property and building as well as oil sector participated widely in Energy Efficiency Agreements. At the end of 2016, agreements covered over 65 percent of Finland’s total energy use (371 TWh, 2016).'
            },
            {
              title: 'Central part of Finland’s energy policy',
              paragraph: 'In Finland, the Energy Efficiency Agreement Scheme has had a central role in implementing national energy and climate strategies, EU energy efficiency obligations as well as international climate agreements since 1997. Energy Efficiency Agreements have a central role for achieving Finland’s energy efficiency obligations under the EU Energy Efficiency Directive (EED, 2012/27/EU).'
            },
            {
              image: '../../assets/images/ETS-taulukko-eng-11.svg',
              backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
            },
            {
              title: 'Necessary energy efficiency',
              paragraph: 'The efficient use of energy is an act of responsibility and one of the key means to mitigate climate change. Energy efficiency is globally recognized “first fuel” when aiming to reduce energy consumption and greenhouse gas emissions.'
            }
          ];
        break;
      case 'ministerin-alkusanat':
        this.backgroundGradient = 'linear-gradient(#9b58b6, #cf3887)';
        this.pageTitle = 'Ministerin alkusanat';
        this.pageContents =
          [
            {
              paragraph: 'Hallitusohjelmaan sisältyvä uusiutuvan energian osuuden nostaminen 50 prosenttiin jo nykyisestä, lähes 40 prosentin osuudesta vaatii ponnistuksia joka sektorilla. Kasvihuonekaasupäästöjä on rajoitettava Pariisin sopimuksen linjausten vauhdittamana. Lisäksi energiatehokkuutta on entisestään parannettava, sillä mitä vähemmän energiaa tarvitaan, sen suurempaan osuuteen uusiutuvan energian resurssit riittävät.'
            },
            {
              paragraph: 'Energiatehokkuus niin teollisuudessa kuin rakennuksissamme on maailman kärkikastia. Myös bioenergian hyödyntäjänä Suomi on maailman huippumaita. Näitä vahvuuksia meidän kannattaa ja pitää hyödyntää myös uutta kasvua yhdessä ja yhteisvoimin rakentaessa.'
            },
            {
              paragraph: 'Energiatehokkuus on läpileikkaava teema koko energia- ja ilmastostrategiassa ja on siten strategiatyön ja toimeenpanon keskiössä. Kaikki energiatehokkuustoimet ja energiatehokkuuden paraneminen auttavat hallitusohjelman energiatavoitteiden saavuttamisessa.'
            },
            {
              paragraph: 'Vapaaehtoisuuteen perustuvat sopimukset ovat valtion ja toimialojen yhdessä valitsema keino täyttää Suomelle asetetut kansainväliset energiatehokkuusvelvoitteet ilman uutta lainsäädäntöä tai muita uusia pakkokeinoja.'
            },
            {
              paragraph: 'Suomi on yksi harvoista Euroopan maista, joissa vapaaehtoinen sopimusmenettely toimii ja tuottaa hyviä tuloksia. Vuosina 2008-2016 raportoitu vuotuinen energiansäästö oli lähes 16 terawattituntia ja siitä saatavat vuosittaiset säästöt ovat energiakustannuksissa jopa 560 miljoonaa euroa.'
            },
            {
              paragraph: 'Energiatehokkuussopimukset ovat tärkeä osa Suomen energia- ja ilmastostrategiaa ja ensisijainen keino edistää energian tehokasta käyttöä Suomessa. Monet yritykset ja yhteisöt ovat olleet mukana nykymuotoisten sopimusten toimeenpanossa ihan alusta, vuodesta 1997, lähtien. Virtaa näyttää riittävän edelleen, hyvä niin. Olen tyytyväinen, kun iso joukko toimijoita on sitoutunut energiatehokkuuden parantamiseen hyvin konkreettisilla toimilla. Vastuullisten joukkoon mahtuu vielä mukaan. Vuoden 2017 alussa solmittu uusi energiatehokkuussopimuskausi on sarjassaan jo kolmas. Nyt olisi tilaisuus sopimusalojen väliselle yhteistyölle esimerkiksi joustavien energiaverkkojen, älykkäiden kaupunkien ja teollisten symbioosien testaamisessa ja hyödyntämisessä myös vientiämme ajatellen.  Tehdään siitä jälleen uusi menestystarina suomalaisen osaamisen ja yhteistyön voimasta.'
            },
            {
              avatarImage: '../../assets/images/kimmotiilikainen.jpg',
            },
            {
              title: 'Kimmo Tiilikainen',
              paragraph: 'Asunto-, energia- ja ympäristöministeri'
            },
            {
              imageCredits: 'Kuva: Sakari Piipponen/valtioneuvoston kanslia'
            }
          ];
        this.pageTitleEN = 'Minister\'s forewords';
        this.pageContentsEN =
          [
            {
              paragraph: 'Increasing the share of renewable energy from the current 40 percent to 50 percent, as agreed in the Government Programme, requires efforts in all sectors. Greenhouse gas emissions need also to be speed up based on alignments in the Paris Agreement. Additionally, energy efficiency should be improved, since the less energy is needed, the greater the proportion of renewable energy resources can cover.'
            },
            {
              paragraph: 'The level of energy efficiency in our industries and buildings is one of the highest in the world. Also as a user of bioenergy, Finland is one of the top countries globally. We should, and need to, make use of these strengths as we create new growth together.'
            },
            {
              paragraph: 'Energy efficiency is a cross-cutting issue throughout the national Climate and Energy Strategy and is therefore at the core of strategic work and implementation. All energy efficiency measures and improved energy efficiency support the accomplishment of the energy targets of the Government Programme.'
            },
            {
              paragraph: 'Voluntary agreements are an approach that the government and sectors have jointly chosen for fulfilling Finland’s international energy efficiency obligations, without the need for new regulations and obligations.'
            },
            {
              paragraph: 'Finland is one of few European countries where a voluntary agreements approach works and is producing good results. During the years 2008-2016, reported annually energy savings were nearly 16 terawatt hours and the resulting savings in annual energy costs was up to 560 million euros.'
            },
            {
              paragraph: 'Energy Efficiency Agreements are an important part of Finland’s Energy and Climate Strategy and the primary means for promoting efficient energy use in Finland. Many companies and communities have participated Energy Efficiency Agreements since the beginning in 1997. There is enough drive, which is good. I am pleased that such a large group of actors has already committed to improve energy efficiency through very concrete actions. The new Energy Efficiency Agreements period, which was agreed in the beginning of 2017, is already the third in the series. Now would be an opportunity for co-operation between the Agreements parties, for example, to test and make use of flexible energy networks, smart cities and industrial symbiosis, bearing in mind also our exports. Let us, once again, make it a success story of the power of Finnish expertise and cooperation.'
            },
            {
              avatarImage: '../../assets/images/kimmotiilikainen.jpg'
            },
            {
              title: 'Kimmo Tiilikainen',
              paragraph: 'Minister of the Environment, Energy and Housing'
            },
            {
              imageCredits: 'Photo: Sakari Piipponen/Finnish Government'
            }
          ];
        break;
      case 'mita-saavutimme-vuosina-2008-2016':
        this.backgroundGradient = 'linear-gradient(#ff604c, #e67d21)';
        this.pageTitle = 'Mitä saavutimme vuosina 2008-2016?';
        this.pageContents =
        [
          {
            paragraph: 'Energiatehokkuussopimuksissa oli mukana yhteensä 667 yritystä ja niiden noin 5000 toimipaikkaa sekä 132 kuntaa ja kuntayhtymää. Liittyjät toteuttivat kaikkiaan yli 21 000 energiatehokkuustoimenpidettä.'
          },
          {
            paragraph: 'Elinkeinoelämässä ja kunta- sekä kiinteistöalalla vuosina 2008–2016 toteutetut tehostamistoimet vähensivät Suomen vuotuista energiankulutusta yhteensä lähes 16 terawattituntia vuoden 2016 lopussa. Säästetystä energiasta lämpöenergian ja polttoaineiden säästöä oli 11,9 TWh (75 %) ja loput 4 TWh (25 %) sähkönsäästöä.'
          },
          {
            image: '../../assets/images/Tulokset_2008-2016-02.svg',
            backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
          },
          {
            paragraph: 'Saavutetusta energiansäästöstä 68 prosenttia toteutui teollisuudessa, 25 prosenttia energia-alalla ja loput 7 prosenttia muilla aloilla.'
          },
          {
            paragraph: 'Toimet vähensivät liittyneiden yritysten ja kuntien energiakustannuksia kaikkiaan yli 560 miljoonaa euroa vuosittain. Ilmastonmuutosta kiihdyttäviä hiilidioksidipäästöjä ne vähensivät vuosittain noin 4,7 miljoonaa tonnia.'
          },
          {
            paragraph: 'Vuosien 2008–2016 aikana valtio myönsi energiatukea liittyneille yhteensä lähes 105 miljoonaa €, josta energiakatselmuksiin 13 miljoonaa euroa ja energiansäästöinvestointeihin 92 miljoonaa euroa. Toimijoiden energiatehokkuusinvestoinnit vuosina 2008–2016 olivat yhteensä yli 1,3 miljardia euroa. Niistä 41 % toteutettiin teollisuudessa, 25 % energiantuotannossa, 16 % palvelualalla, 10 % energiansiirrossa ja -jakelussa ja 8 % kiinteistöalalla.'
          },
          {
            image: '../../assets/images/ETS-energiansaasto-02.svg',
            backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
          }
        ];
        this.pageTitleEN = 'What was achieved during 2008-2016?';
        this.pageContentsEN =
          [
            {
              paragraph: 'A total of 667 companies, with about 5,000 sites, and 132 communities and joint municipalities participated in the Energy Efficiency Agreements in 2008-2016. During these years they implemented over 21,000 energy efficiency measures.'
            },
            {
              paragraph: 'Energy efficiency measures implemented in industries, municipalities as well as in property and building sector decreased Finland’s annual energy consumption by almost 16 terawatt hours by the end of 2016. Of the saved energy, 11.9 TWh (75 %) was heat and fuels and the remaining 4 TWh (25 %) was electricity.'
            },
            {
              image: '../../assets/images/Tulokset_2008-2016-eng-03.svg',
              backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
            },
            {
              paragraph: 'Of the achieved energy savings, 68 percent were realised in the industrial sector, 25 percent in the energy production sector and the remaining 7 percent in other sectors.'
            },
            {
              paragraph: 'At the end of 2016 the measures reduced the energy costs of the participating companies and municipalities in total by more than 560 million euros a year. They reduced carbon dioxide emissions by 4.7 million tonnes a year.'
            },
            {
              paragraph: 'During 2008-2016, the Government of Finland granted almost 105 million euros in energy subsidies, of which 13 million euros were for energy audits and 92 million euros were for energy efficiency investments. Correspondingly participants invested in total over 1.3 billion euros in energy efficiency measures during 2008-2016. Of these, 41 % were realised in industry, 25 % in energy production, 16 % in the service sector, 10 % in energy transmission and distribution and 8 % in the property and building sector.'
            },
            {
              image: '../../assets/images/ETS-energiansaasto-02.svg',
              backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
            }
          ];
        break;
      case 'vapaaehtoisuuden-voimalla':
        this.backgroundGradient = 'linear-gradient(#9b58b6, #cf3887)';
        this.pageTitle = 'Vapaaehtoisuuden voimalla';
        this.pageContents =
          [
            {
              paragraph: 'Vapaaehtoisuuteen pohjautuvat sopimukset ovat keino tehostaa energiankäyttöä Suomessa tavalla, joka hyödyttää kaikkia osapuolia.'
            },
            {
              paragraph: 'Vapaaehtoisuus on koettu Suomessa toimivammaksi ratkaisuksi kuin lakiin tai säädöksiin perustuva velvoitejärjestelmä. Vapaaehtoisuuden pohjalle rakennetut sopimukset poikivat hyötyjä, joita velvoitejärjestelmällä on vaikea saavuttaa.'
            },
            {
              smalltitle: 'Sopimukset ovat kustannustehokkain tapa saavuttaa kansalliset energiatehokkuustavoitteet.',
              paragraph: 'Sopimusjärjestelmä on ollut Suomelle kiistatta kannattava investointi. Valtion hallinnolliset kustannukset sopimusjärjestelmän ylläpitoon ovat verrattain maltilliset saavutettuihin hyötyihin nähden. On arvioitu, että velvoiteohjelma vaatisi moninkertaiset resurssit.'
            },
            {
              smalltitle: 'Enemmän hyötyä suoriutumisen sijaan.',
              paragraph: 'Nyt yritykset ja kunnat toteuttavat taloudellisesti kannattavia toimia, omassa tahdissaan. Näin toteutuslistalle valikoituu iso joukko kannattavia ja hyödyllisiä toimia. Näin ei välttämättä olisi, jos käytössämme olisi lakiin perustuvat velvoitteet.'
            },
            {
              smalltitle: 'Toimintaa vauhdittaa valtion taloudelliset kannustimet.',
              paragraph: 'Vain sopimukseen liittyneillä toimijoilla on mahdollista saada investointitukea tavanomaisen tekniikan energiatehokkuustoimille. Investointeja ei voitaisi tukea, jos käytössä olisi energiatehokkuuden velvoitejärjestelmä. Investointituki on yksi keskeinen houkutin liittyjille ja mahdollisuus nostaa toteutuslistalle sellaisia energiatehokkuustoimia, jotka muuten jäisivät tekemättä.'
            },
            {
              smalltitle: 'Sopimustoiminnan ympärille muodostuneet ammattilaisverkostot tukevat toiminnan aktiivisuutta',
              paragraph: 'Yhteisen tavoitteen edessä eri alojen toimijat ovat ennakkoluulottomasti ja avoimesti etsineet yhdessä keinoja tehostaa energiankäyttöään.'
            },
            {
              quote: '”Energiatehokkuussopimukset ovat vuosien varrella käytännössä osoittaneet toimivuutensa. Sopimukset ovat malliesimerkki suomalaisesta sopimusyhteiskunnasta ja meidän kyvystä ratkaista kansallisesti tärkeitä asioita yhteisesti sopien.”',
              author: 'ylijohtaja Simo Nurmi, Energiavirasto'
            },
            {
              title: 'Tässä onnistuimme'
            },
            {
              smalltitle: 'Verkostoituminen ja alojen välinen yhteistyö',
              paragraph: 'Eri toimijoita yhdistävä tavoite ja tahtotila sekä sopimusosapuolten välinen luottamus ovat luoneet hyvän pohjan saumattomalle yhteistyölle. Keskusteluyhteys eri sopimusosapuolten välillä on ollut avointa ja aktiivista läpi sopimuskauden. Niin valtionhallinnolla kuin mukana olevilla toimialoilla ja liittyneillä on ollut aito halu saavuttaa energiatehokkuudelle asetetut tavoitteet − vapaaehtoisesti ja kustannustehokkaasti.'
            },
            {
              paragraph: 'Erilaiset toimialarajat ylittävät työryhmät ovat tarjonneet liittyjille arvokkaaksi koettua ideointi- ja vertaisoppimistukea sekä foorumin energiatehokkuuteen keskitty- välle avoimelle tiedonvaihdolle. Vuosina 2008-2016 eri alojen toimijat ovat yhteistyössä ratkoneet erilaisia energiatehokkuushaasteita valtion omistaman asiantuntijayritys Motivan johdolla.'
            },
            {
              list: [
                'Paineilma, 2008',
                'Kylmäjärjestelmät, 2008',
                'Ammattikeittiöt, 2009',
                'Hiihtokeskukset, 2010',
                'Konesalit, 2011',
                'Höyry- ja lauhdejärjestelmät, 2011',
                'Teollisuuden kiinteistöt, 2012',
                'Tuotannon ylijäämälämpö, 2013',
                'Teollisuusuunit, 2014',
                'Valaistus, 2015',
                'Lämmönsiirto, 2016',
                'Teollisuuden tekniset eristeet, 2016',
                'Tehdaskiinteistön ilmavaihto, 2016',
                'Vesihuoltolaitokset, 2016'
              ]
            },
            {
              paragraph: 'Työhön on osallistunut vuosien varrella yli 150 yritystä ja yhteisöä. Yhteistyössä koottu tieto palvelee energiatehokkuustyötä koko Suomessa.'
            },
            {
              title: 'Mitä hyötyä sopimuksista?'
            },
            {
              smalltitle: 'Liittyjän hyödyt'
            },
            {
              list: [
                'Joustava ja kannustava väline yrityksen tai yhteisön energiatehokkuuden kehittämiseen',
                'Fiksumpi energiankäyttö on vastuullinen ilmastoteko, joka kohentaa liiketoiminnan tulosta',
                'Liittyjä voi hakea valtion tukea energiatehokkuusinvestointeihin',
                'Ohjaa energiatehokkuuden seuraamiseen ja jatkuvaan parantamiseen',
                'Nivoo energiatehokkuuden osaksi ympäristö- ja johtamisjärjestelmiä',
                'Rakentaa ja vahvistaa myönteistä julkisuuskuvaa'
              ],
            },
            {
              smalltitle: 'Kansalliset hyödyt'
            },
            {
              list: [
                'Keino täyttää EU:n monia energiatehokkuusvelvoitteita Suomessa',
                'Vaihtoehtoinen ja täydentävä keino lainsäädännölle/pakkokeinoille',
                'Ei verotuksen tai lainsäädännön haitallisia vaikutuksia suomalaisyritysten kilpailukykyyn',
                'Auttaa kasvihuonekaasupäästövelvoitteiden saavuttamisessa',
                'Edistää osaltaan Suomen huoltovarmuutta ja energiaomavaraisuutta',
                'Luo vihreää kasvua & markkinoita puhtaan teknologian ratkaisuille'
              ],
            }
          ];
        this.pageTitleEN = 'The power of voluntary action';
        this.pageContentsEN =
          [
            {
              paragraph: 'Voluntary agreements are a way of enhancing energy efficiency in Finland in a way that benefits all parties.'
            },
            {
              paragraph: 'In Finland, voluntary action has been found to be a better option than an obligation system that is based on legislation and regulations. The Agreement Scheme based on voluntary commitments result benefits that mandatory schemes have difficulties to offer.'
            },
            {
              smalltitle: 'The most cost-effective way to achieve national energy efficiency targets.',
              paragraph: 'The Agreements Scheme has undoubtedly been a profitable investment for Finland. The Government\'s administrative costs for maintaining the Agreements Scheme are relatively low in relation to the benefits gained. It is estimated that an obligation system would require many times more resources.'
            },
            {
              smalltitle: 'Voluntariness boosts benefits.',
              paragraph: 'Companies and municipalities are implementing economically viable measures at their own pace. In this way a large number of profitable and valuable energy efficiency measures will be implemented. This would not necessarily be the case if we had legal obligations.'
            },
            {
              smalltitle: 'The government’s financial incentives accelerate activities.',
              paragraph: 'Only participants in the Energy Efficiency Agreement Scheme can get investment subsidies for energy efficiency measures based on conventional technology. It would not be possible to grant corresponding investment subsidies under an energy efficiency obligation scheme. Possibility for investment subsidies is one essential motivator for participants to join the Agreement Scheme and an opportunity to implement energy efficiency measures that might otherwise not be taken.'
            },
            {
              smalltitle: 'Professional networks formed around the Agreements support and increase activity.',
              paragraph: 'With a common target, actors from different sectors are jointly looking for ways to enhance energy efficiency in good and fruitful collaboration.'
            },
            {
              quote: '"Over the years, Energy Efficiency Agreements have demonstrated their effectiveness. The Agreements are a good example of Finnish way and ability to solve nationally important issues through joint negotiations and actions."',
              author: 'Director General Simo Nurmi, Energy Authority'
            },
            {
              title: 'Benefits of the agreements'
            },
            {
              smalltitle: 'Benefits to participants'
            },
            {
              list: [
                'Flexible and motivating tool for developing the energy efficiency in the company or municipality',
                'Smarter energy use is a responsible climate act, which enhances business profit',
                'Participants can apply for government subsidies for energy efficiency investments',
                'Steers to monitoring of energy efficiency and continuous improvement',
                'Links energy efficiency to management systems',
                'Builds and strengthens a positive public image'
              ],
            },
            {
              smalltitle: 'National benefits'
            },
            {
              list: [
                'Means of fulfilling EU energy efficiency obligations in Finland',
                'Alternative and complementary approach to regulations and obligations',
                'No negative impacts of taxation or legislation on the competitiveness of Finnish businesses',
                'Helps to achieve greenhouse gas emission reduction obligations',
                'Enhances Finland’s security of supply and self-sufficiency of energy',
                'Creates green growth and markets for clean technology solutions'
              ],
            }
          ];
        break;
      case 'menestystekijat':
        this.backgroundGradient = 'linear-gradient(#f0c40f, #27ad5f)';
        this.pageTitle = 'Menestystekijät';
        this.pageContents =
          [
            {
              paragraph: 'Vuosien saatossa suomalaiset vapaaehtoiset energiatehokkuussopimukset ovat muovautuneet menestystarinaksi, jollaista ei löydy muualta maailmasta. Menestyksen takaa löytyy useita tekijöitä, jotka ovat kaikki osaltaan vaikuttaneet järjestelmän toimivuuteen ja tuloksellisuuteen Suomessa.'
            },
            {
              title: 'Menestyksen avaimet'
            },
            {
              twoColumnsTitle: 'Vapaaehtoisuus',
              list: [
                'Lakisääteisten tai muiden velvoittavien keinojen sijaan liittyjälle joustavampi ja mielekkäämpi tapa toteuttaa energiatehokkuustoimia ja -investointeja tarvelähtöisesti, kukin yritys ja kunta omassa tahdissaan',
                'Vapaaehtoisuus on sopimusosapuolten yhteinen tahtotila'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#3497db, #9b58b6)'
            },
            {
              twoColumnsTitle: 'Järkevyys & kustannustehokkuus',
              list: [
                'Energiatehokkuus on sopimukseen liittyjälle järkevää ja taloudellisesti kannattavaa toimintaa',
                'Hallinnollisesti kevyempi toteuttaa kuin energiayhtiöiden velvoitejärjestelmä'
              ],
              backgroundGradient: 'linear-gradient(#cf3887, #e67d21)'
            },
            {
              twoColumnsTitle: 'Vaikuttavuus',
              list: [
                'Vuosina 2008-2016 sopimustoiminta kattoi yli 65 % Suomen kokonaisenergiankulutuksesta',
                'Paljon toteutettuja ja raportoituja toimia – säästövaikutus suuri'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              twoColumnsTitle: 'Läpinäkyvyys',
              list: [
                'Hyvä raportointiaste',
                'Toimien vuosittainen raportointi mahdollistaa kansallisen sitovan energiansäästötavoitteen saavuttamisen osoittamisen EU:n suuntaan',
                'Ilman vuosittaista raportointia ja seurantaa vapaaehtoisuuteen perustuvan ohjauskeinon hyödyntäminen EED:n toimeenpanossa ei olisi Suomelle mahdollista'
              ],
              backgroundGradient: 'linear-gradient(#9b58b6, #cf3887)'
            },
            {
              twoColumnsTitle: 'Luottamus & yhteistyö',
              list: [
                'Sopimusosapuolten yhteistyökyky ja -halu',
                'Toimivat, luontevat ja luottamukselliset suhteet valtionhallinnon, toimialaliittojen ja sopimukseen liittyneiden toimijoiden kesken'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
            },
            {
              twoColumnsTitle: 'Sitoutuneisuus',
              list: [
                'Sopimukseen liittyneiden aito sitoutuminen tavoitteisiin',
                'Sopimusosapuolten vastuuhenkilöiden aktiivisuus'
              ],
              backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
            },
            {
              twoColumnsTitle: 'Taloudellinen ja toiminnallinen tuki',
              list: [
                'Valtion energiatuki investoinneille ja energiakatselmuksille',
                'Valtion ja toimialaliittojen rahoittama puolueeton neuvonta ja toimeenpanon tuki',
                'Uutta energiatehokkuustietoa liittyneiden käyttöön',
                'Verkostot ja vertaistuki'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#9b58b6, #cf3887)'
            },
            {
              twoColumnsTitle: 'Rakenteelliset tekijät',
              list: [
                'Pitkä historia ja kokemus sopimusjärjestelmästä – vakiintunut menettely',
                'Toimialaliittojen keskeinen ja aktiivinen rooli Suomessa'
              ],
              backgroundGradient: 'linear-gradient(#f0c40f, #27ad5f)'
            },
            {
              quote: '”Sopimuksiin liittyvät tavoitteenasettelut, katselmukset ja säännöllinen raportointi muodostavat selkeän rungon itse energiatehokkuustyölle. Verkostot muiden sopimukseen liittyneiden yritysten ja asiantuntijoiden välillä ovat tärkeitä.”',
              author: 'johtava asiantuntija Juha Kouki, Pohjolan Voima',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/pohjolan-voima-tieto-tuo-energiatehokkuutta',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Meillä on energiatehokkuussopimuksesta hyvät kokemukset. Olemme mukana isommassa viitekehyksessä, joka antaa puitteet omiin energiansäästötoimiin. Lisäksi sopimuksen edellyttämä säännöllinen raportointi pitää energiatehokkuusasiat hyvin mielessä.”',
              author: 'kunnanjohtaja Ari Alatossava, EU:n ilmastopalkinnon vuonna 2017 saanut Iin kunta',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/iin-kunta-koululaiset-innostuivat-energiansaastosta',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Energiatehokkuussopimus on tarjonnut työkaluja, osaamista ja mahdollisuuden saada tukea energiankäyttöä tehostaviin investointeihin. Näin pääsimme nopeasti liikkeelle. Energiakulut ovat meille kolmanneksi suurin kuluerä henkilöstön ja markkinoinnin jälkeen. Lumetukseen kuluu vuosittain noin puoli miljoonaa euroa, mutta ilman säästötoimenpiteitä lasku olisi kymmeniä tuhansia euroja isompi.”',
              author: 'hallituksen puheenjohtaja Kari Jussi Aho, Rukakeskus Oy ja Pyhätunturi Oy',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/pohjoismaiden-ensimmainen-hiilineutraali-hiihtokeskus',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Suomi mainitaan aina ensimmäisenä, kun EU:ssa puhutaan vapaaehtoisista energiatehokkuusjärjestelmistä. Sopimusjärjestelmämme vahvuuksia ovat laaja kattavuus sekä kokonaisvaltainen hallinnointi ja raportointi. Tietääkseni missään muualla yhteistyö julkisten ja yksityisten toimijoiden välillä ei ole yhtä sujuvaa.”',
              author: 'neuvotteleva virkamies Pentti Puhakka, työ- ja elinkeinoministeriö',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/vapaaehtoiset-sitoumukset-ovat-iso-voimavara',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Sopimuksiin yhdessä toimialaliittojen ja kuntien kanssa päätetyt velvoitteet ovat riittävän yksinkertaiset toimiakseen. Liittyjiltä velvoitetaan vain kokonaisuuden kannalta välttämättömät toimet. Näistä keskeisimmät ovat energiatehokkuustoimien toteuttaminen ja toimien raportointi. Tehtyjen toimien raportointi on välttämättömyys, jotta energiansäästövaikutusta on mahdollista seurata kansallisella tasolla ja näyttää toteen EU:n suuntaan.”',
              author: 'johtaja Heikki Väisänen, Energiavirasto',
            }
          ];
        this.pageTitleEN = 'Why do the agreements work?';
        this.pageContentsEN =
          [
            {
              paragraph: 'Over the years, Finnish voluntary Energy Efficiency Agreements have evolved into a unique success story that is not found elsewhere in the world. There are several factors behind the success, all of which have contributed to the functionality and performance of the Scheme in Finland.'
            },
            {
              title: 'Keys to success'
            },
            {
              twoColumnsTitle: 'Voluntariness',
              list: [
                'Instead of legislative or other obligatory means, a more flexible and functional way for participants to implement energy efficiency measures and investments, each company and municipality at its own pace',
                'Voluntariness is the common will of the Agreement parties'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#3497db, #9b58b6)'
            },
            {
              twoColumnsTitle: 'Feasibility & cost-efficiency',
              list: [
                'Energy efficiency is rational and economically profitable',
                'Administratively lighter to implement than an energy efficiency obligation Scheme'
              ],
              backgroundGradient: 'linear-gradient(#cf3887, #e67d21)'
            },
            {
              twoColumnsTitle: 'Effectiveness',
              list: [
                'During 2008-2016, the Agreement Scheme covered over 65 % of Finland\'s total energy consumption',
                'Large amount of implemented and reported actions - a substantial energy savings impact'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              twoColumnsTitle: 'Transparency',
              list: [
                'Participants committed to fulfil their annual reporting obligation',
                'Annual reporting of implemented saving measures and other agreement obligations enables monitoring of the fulfilment of national energy efficiency obligations to the EU',
                'Annual reporting by participants combined with reliable monitoring and verification system enables Finland to make use of the voluntary Agreement Scheme to implement the EED Article 7 savings obligation.'
              ],
              backgroundGradient: 'linear-gradient(#9b58b6, #cf3887)'
            },
            {
              twoColumnsTitle: 'Trust & cooperation',
              list: [
                'Ability and willingness of Agreement parties to cooperate',
                'Functional, natural and confidential relationships between the government administration, sector and branch associations and participating companies and municipalities'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
            },
            {
              twoColumnsTitle: 'Commitment',
              list: [
                'Participants genuinely commitment to energy efficiency',
                'Active involvement of the responsible persons in the Agreement parties'
              ],
              backgroundGradient: 'linear-gradient(#ff604c, #e67d21)'
            },
            {
              twoColumnsTitle: 'Financial and operational support',
              list: [
                'Government energy subsidies for energy audits and energy efficiency investments',
                'Unbiased advice financed by the government and branch associations',
                'New and useful information about energy efficiency',
                'Networks and peer support'
              ],
              class: 'odd',
              backgroundGradient: 'linear-gradient(#9b58b6, #cf3887)'
            },
            {
              twoColumnsTitle: 'Structural factors',
              list: [
                'Long established history and good experiences of the Agreement Scheme',
                'Central and active role of sector and branch associations in Finland'
              ],
              backgroundGradient: 'linear-gradient(#f0c40f, #27ad5f)'
            },
            {
              quote: '"Agreement target setting, energy audits and regular reporting provide a clear framework for energy efficiency work. The networks between participating companies and experts are important."',
              author: 'Senior expert Juha Kouki, Pohjolan Voima'
            },
            {
              quote: '"We have good experiences with the Energy Efficiency Agreements. We are part of a larger framework that draws up guidelines for our own energy savings work. In addition, the regular reporting required by the Agreement keeps energy efficiency matters well in mind."',
              author: 'Mayor Ari Alatossava, Municipality of Ii, winner of an EU RegioStars award in 2017'
            },
            {
              quote: '"The Energy Efficiency Agreement has provided tools, know-how and the possibility to receive support for investments that improve energy efficiency. This enabled us to act quickly. Energy costs are the third biggest expense for us after staff and marketing expenditures. We spend approximately half a million euros each year on snowmaking; without saving measures, the bill would be tens of thousands of euros higher."',
              author: 'Chairman of the Board Kari Jussi Aho, Rukakeskus Oy and Pyhätunturi Oy'
            },
            {
              quote: '"Finland is always mentioned first when voluntary energy efficiency schemes are discussed in the EU. The strengths of our Agreement Scheme are extensive coverage of our energy use as well as comprehensive administration and reporting. As far as I know, nowhere else cooperation between the public and private sectors is as smooth."',
              author: 'Chief councellor Pentti Puhakka, the Ministry of Economic Affairs and Employment'
            },
            {
              quote: '"The Agreements requirements are simple enough to work. Parties are only obliged to take actions that are necessary on the whole. The most important of these are the implementation of energy efficiency measures and the reporting of activities. Reporting is essential to keep track of the effects of energy saving measures at the national level and to be able to report this forward to the EU."',
              author: 'johtaja Heikki Väisänen, Energiavirasto',
            }
          ];
        break;
      case 'takana-pitka-historia':
        this.backgroundGradient = 'linear-gradient(#e67d21, #f0c40f)';
        this.pageTitle = 'Takana pitkä historia';
        this.pageContents =
          [
            {
              paragraph: 'Toimivaa energiatehokkuussopimusjärjestelmää ei rakenneta hetkessä, vaan se on vaatinut vuosien työn.  Päättynyt sopimuskausi oli järjestyksessään toinen. Suomessa energian tehokasta käyttöä on edistetty valtion ja toimialojen välisillä sopimuksilla jo 1990-luvulta lähtien. Pitkäjänteinen toiminta on auttanut luomaan menettelyn, joka ohjaa ja kannustaa yrityksiä ja yhteisöjä sopimuksen mukaisten tavoitteiden saavuttamiseen. Jokaisella sopimuskaudella olemme yltäneet asetettuihin tavoitteisiin.'
            },
            {
              paragraph: 'Komissio nosti ensimmäistä kertaa laajasti energiatehokkuuden agendalleen, kun komissio antoi ehdotuksen energiapalveludirektiivistä (2006/32/EY). Tätä ennen EU ei ollut asettanut energiatehokkuusvelvoitteita jäsenmailleen. Suomen osalta direktiivin toimeenpanoon hyväksyttiin sopimusjärjestelmä, joka oli ollut jo vuosien ajan käytössä ja havaittu meillä toimivaksi tavaksi tehostaa energiankäyttöä.'
            },
            {
              smalltitle: 'Sopimukset vastaavat EU-velvoitteisiin',
              paragraph: 'Energiapalveludirektiivin tavoite oli saavuttaa vuonna 2016 yhdeksän prosentin säästö vuosien 2001–2005 keskimääräisestä, päästökaupan ulkopuolelle jäävästä, energian loppukäytöstä. Vuonna 2008 käynnistyneitä sopimuksia laajennettiin kattamaan direktiiviin kuuluvia aloja, joille energiatehokkuussopimuksiin osallistuminen ei ollut aiemmin mahdollista. Elinkeinoelämän energiatehokkuussopimukseen sitoutuivat teollisuuden ja energia-alan lisäksi ensimmäistä kertaa matkailu- ja ravintola-ala, autoala ja kaupan ala. Kunta-alan sopimus jaettiin kahteen osaan isoille kaupungeille ja kuntayhtymille tarkoitettuun kuntien energiatehokkuussopimukseen ja pienille kunta-alan toimijoille suunnattuun energiaohjelmaan.'
            },
            {
              paragraph: 'Samaan aikaan öljyalan kolmas energiatehokkuussopimus - HÖYLÄ III laajeni kattamaan öljylämmityskiinteistöjen ohella liikennepolttonesteiden loppukäytön. Kiinteistö- ja rakennusalan sopimus korvattiin Kiinteistöalan energiatehokkuussopimuksella. Se kattoi vuonna 2010 käynnistyneen vuokra-asuntoyhteisöjen toimenpideohjelman ja vuonna 2011 käynnistyneen toimitilakiinteistöjen toimenpideohjelman. Sekä HÖYLÄ III -sopimus että vuokra-asuntoyhteisöjen toimenpideohjelma toimeenpanivat myös rakennusten energiatehokkuusdirektiivin EPBD (2010/31/EU) velvoitteita.'
            },
            {
              image: '../../assets/images/ETS-aikajana-uusi-07.svg',
              backgroundGradient: 'linear-gradient(#e67d21, #f0c40f)'
            },
            {
              smalltitle: 'Velvoitteet kiristyvät - sopimus pysyy',
              paragraph: 'Kesken toisen sopimuskauden, vuonna 2014, alkoi energiapalveludirektiivin korvanneen energiatehokkuusdirektiivin EED (2012/27/EU) toimeenpano. Sen 7 artiklan mukaisesti jäsenvaltiot asettivat kansallisen sitovan kumulatiivisen energiansäästötavoitteen kaudelle 2014–2020. Suomi käyttää direktiivissä annettua mahdollisuutta toimeenpanna velvoite vaihtoehtoisilla toimilla. Sopimuksilla on Suomessa keskeinen rooli sitovan tavoitteen saavuttamisessa.'
            },
            {
              paragraph: 'Energiatehokkuussopimukset ovat olleet Suomelle toimiva ja sopivan joustava työkalu energiankäytön tehostamistavoitteiden saavuttamiseksi. Sopimusten avulla on ollut mahdollista saavuttaa EU-direktiivien kautta asetetut Suomen energiansäästötavoitteet sekä energian tehokasta käyttöä tukevien direktiivien (ESD, EED, EPBD) monet muut velvoitteet.'
            },
            {
              paragraph: 'Vuonna 2016 valmistui uusi kansallinen energia- ja ilmastostrategia. Se linjaa konkreettisia toimia ja tavoitteita, joilla Suomi saavuttaa kansalliset ja EU:ssa sovitut energia- ja ilmastotavoitteet vuoteen 2030.  Tavoitteiden saavuttamisessa tuloksellisilla energiatehokkuussopimuksilla on tärkeä rooli.'
            },
            {
              smalltitle: 'Uusi sopimuskausi vuosille 2017-2015'
            },
            {
              highlight: 'Uusi, vuonna 2017 alkanut ja vuoteen 2025 ulottuva energiatehokkuussopimuskausi jatkaa ansiokasta energiatehokkuustyötä Suomessa.',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi',
              linktitle: 'Lue lisää'
            }
          ];
        this.pageTitleEN = 'The long history of the agreements';
        this.pageContentsEN =
          [
            {
              paragraph: 'To build up a functioning Energy Efficiency Agreements system has required years of work. The completed Agreement period was the second consecutive period. In Finland, the efficient use of energy has been promoted by Agreements between the Government and sectors since the 1990s. Long-term action has helped to create a procedure that guides and encourages companies and municipalities to reach the Agreements targets. In each Agreement period, we have reached the set targets.'
            },
            {
              paragraph: 'For the first time the European Commission extensively brought energy efficiency on to its agenda when it submitted the proposal of the Energy Services Directive ESD (2006/32/EC). Prior to this, the EU had not imposed energy efficiency obligations on its member states. In Finland, it was agreed that the implementation of the directive will be carried out by the Energy Efficiency Agreement Scheme that had been in use for many years and which was recognized as a functional means to enhance efficient energy use.'
            },
            {
              smalltitle: 'Agreements meet EU requirements',
              paragraph: 'The objective of the Energy Services Directive was to achieve, by 2016, savings of nine percent in the annual end-use of energy, excluding emissions trading, compared to the average corresponding energy use during 2001-2005. The Agreements launched in 2008 were extended to include sectors covered by the directive for which participation in Energy Efficiency Agreements was not in the first Agreement period possible. In addition to the industrial and the energy sectors, for the first time also the hotel and restaurant, motor trades and repairs as well as commerce sectors committed to the Energy Efficiency Agreements for the Industries. The Municipal Sectors Agreement was divided into two parts: an Energy Efficiency Agreement for large cities, municipalities and joint municipalities and an Energy Programme for small municipalities and joint municipalities.'
            },
            {
              paragraph: 'At the same time, the third Oil Sector Energy Efficiency Agreement (HÖYLÄ III) was expanded to cover, in addition to oil heated building, also the end use of transport fuels. The Property and Construction Sector Agreement was replaced by the Property and Building Sector Energy Efficiency Agreement, which covered rental housing properties (launched in 2010) as well as commercial properties (launched in 2011). Both the HÖYLÄ III agreement and the action plan for rental housing properties supported also implementation of the requirements of the Energy Performance of Buildings Directive EPBD (2010/31/EU).'
            },
            {
              image: '../../assets/images/ETS-aikajana-eng-12.svg',
              backgroundGradient: 'linear-gradient(#e67d21, #f0c40f)'
            },
            {
              smalltitle: 'Obligations get tighter - Agreements remain',
              paragraph: 'In the middle of the agreement period, in 2014, the Energy Services Directive was replaced by the Energy Efficiency Directive EED (2012/27/EU). Pursuant to its Article 7, member states set a national binding cumulative energy savings target for the period 2014-2020. Finland uses the option provided by the directive to implement the obligation by alternative means. In Finland, the Energy Efficiency Agreements have a central role in achieving the binding target.'
            },
            {
              paragraph: 'Energy Efficiency Agreements have been a well-functioning and flexible tool for Finland to achieve energy efficiency targets. The Agreements have made it possible to achieve the energy saving targets set in Finland in response to the EU directives as well as many other requirements stemming from the directives that support the efficient use of energy (ESD, EED, and EPBD).'
            },
            {
              paragraph: 'A new National Energy and Climate Strategy was completed in 2016. It sets out concrete actions and targets for Finland to achieve national and EU climate and energy targets by 2030. Successful Energy Efficiency Agreements play an important role in achieving these targets.'
            },
            {
              smalltitle: 'New Agreement Period for 2017-2025'
            },
            {
              highlight: 'The new Energy Efficiency Agreements period, which began in 2017 and continues until 2025, will pursue the meritorious energy efficiency work in Finland.',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/en',
              linktitle: 'Read more'
            }
          ];
        break;
      case 'valtio-tukee-energiatehokkuutta':
        this.backgroundGradient = 'linear-gradient(#2b3d4f, #3497db)';
        this.pageTitle = 'Valtio tukee energiatehokkuutta';
        this.pageContents =
          [
            {
              paragraph: 'Työ- ja elinkeinoministeriö tuki tapauskohtaisen harkinnan perusteella elinkeinoelämän, kunta-alan ja kiinteistöalan sopimuksiin liittyneiden yritysten ja yhteisöjen energiatehokkuusinvestointeja. Vuosina 2008-2016 tukea on myönnetty kaikkiaan yli 92 miljoonaa euroa, yhteensä 1025 hankkeelle.'
            },
            {
              paragraph: 'Yritykset ja kunnat ovat investoineet mittavasti energiatehokkuuteen vuosina 2008–2016. Kaikkiaan energiatehokkuusinvestointeja on raportoitu toteutetuksi teollisuudessa, energia-alalla, yksityisellä palvelualalla, kunta-alalla sekä kiinteistöalalla 1,3 miljardin euron edestä.'
            },
            {
              image: '../../assets/images/ETS-myonnetty-investointituki-06.svg',
              backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
            },
            {
              quote: '"Valtio kannustaa energiatuella sopimuskumppaneita toteuttamaan myös hieman pidempää takaisinmaksuaikaa edellyttäviä investointeja, jotka ovat kansantaloutemme ja energiatavoitteidemme kannalta tarpeellisia"',
              author: 'neuvotteleva virkamies Pentti Puhakka, työ- ja elinkeinoministeriö',
            }
          ];
        this.pageTitleEN = 'The government supports energy efficiency';
        this.pageContentsEN =
          [
            {
              paragraph: 'The Ministry of Economic Affairs and Employment provides energy efficiency investment subsidies, based on individual assessment, for companies and communities that have joined the industrial, municipal as well as property and building sector agreements. During 2008-2016, subsidies have been granted for 1,025 projects, 92 million euros in total.'
            },
            {
              paragraph: 'Companies and municipalities have actively invested in energy efficiency in 2008-2016. In total, energy efficiency investments in industry, the energy sector, the municipal sector and the private service sector have been reported as implemented to the value of 1.3 billion euros in 2008–2016.'
            },
            {
              image: '../../assets/images/ETS-myonnetty-investointituki-06.svg',
              backgroundGradient: 'linear-gradient(#2b3d4f, #3497db)'
            },
            {
              quote: '"With the energy subsidies, the Government encourages Agreement parties to also implement slightly longer-term investments that are necessary for our national economic and energy targets."',
              author: 'Chief councellor Pentti Puhakka, the Ministry of Economic Affairs and Employment',
            }
          ];
        break;
      case 'energiakatselmus-viitoittaa-tieta':
        this.backgroundGradient = 'linear-gradient(#27ad5f, #2b3d4f)';
        this.pageTitle = 'Energiakatselmus viitoittaa tietä';
        this.pageContents =
          [
            {
              paragraph: 'Energiakatselmukset tukevat energiatehokkuustoimintaa sopimukseen liittyneissä yrityksissä ja kunnissa. Katselmus on toimiva ja luotettava tapa löytää kannattavimmat keinot tehostaa energiankäyttöä ja vähentää energiakustannuksia.'
            },
            {
              title: 'Mikä on energiakatselmus?',
              paragraph: 'Motiva-mallin mukainen energiakatselmus on perusteellinen ja kattava selvitys rakennuksen tai tuotantolaitoksen energian ja veden käytöstä sekä niiden kannattavista tehostamismahdollisuuksista. Valtio tukee kuntasektorin sekä mikro- ja pk-yritysten Motivan mallin mukaisia energiakatselmuksia.'
            },
            {
              paragraph: 'Vuoden 2015 alusta voimaan tullut, energiatehokkuusdirektiivin toimeenpanoon liittyvä, energiatehokkuuslaki velvoittaa suuret yritykset neljän vuoden välein tekemään yrityksen energiakatselmuksen, joka sisältää myös kohdekatselmuksia. Tämän vuoksi suuret yritykset eivät ole saaneet tukea energiakatselmuksiin 5.6.2014 lähtien.'
            },
            {
              paragraph: 'Elinkeinoelämän, kunta-alan sekä kiinteistöalan sopimuksessa mukana oleville yrityksille ja yhteisöille on vuosina 2008–2016 myönnetty tukea energiakatselmuksiin yhteensä 12,9 miljoonaa euroa. Vuosien 2008-2016 aikana käynnistyi yhteensä 2 563 valtion tukemaa energiakatselmusta.'
            },
            {
              image: '../../assets/images/ETS-energiakatselmusten-ja-tuen-maara-03.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'Vuoteen 2015 asti Suomessa toteutettiin suuri määrä tuettuja energiakatselmuksia. Energiatehokkuusdirektiivin toimeenpanokauden alettua 5.6.2014, suuret yritykset eivät ole enää voineet hakea tukea energiakatselmuksiin, mikä näkyy voimakkaana käynnistyneiden katselmusten ja myönnetyn tuen määrän laskuna.'
            },
            {
              paragraph: 'Kunta-alalla, jota pakolliset energiakatselmukset eivät koske, katselmusten määrä kasvoi tasaisesti koko sopimuskauden ajan.'
            },
            {
              image: '../../assets/images/ETS-teollisuuden-energiakatselmoitu-energiankaytto-04.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'Teollisuudessa vuosina 2008-2016 valtaosa, lähes 90 prosenttia, energiakatselmuksista liittyi sopimustoimintaan. Vuonna 2016 teollisuuden energian loppukulutus Suomessa oli noin 136 TWh. Teollisuuden energiankäyttö on katselmoitu pääosin vähintään kertaalleen.'
            },
            {
              image: '../../assets/images/ETS-palvelualan-energiakatselmointi-tilavuus-05.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'Vuoden 2016 lopussa koko palvelurakennuskannan tilavuudesta yli 60 prosenttia on katselmoitu vähintään kertaalleen. Vuosina 2008-2016 yksityisellä palvelusektorilla puolet energiakatselmuksista on toteutettu energiatehokkuussopimukseen liittyneissä yrityksissä. Kuntasektorilla vastaava luku on 95 prosenttia.'
            },
            {
              quote: '”Energiakatselmus antoi erinomaisen pohjan käytännön energiansäästötoimille. Suurin tehostamispotentiaali löytyi tuotantoprosessissa syntyvän hukkalämmön hyödyntämisestä. Investoimme lämpöpumppuihin heti katselmuksen jälkeen. Näin otimme suurimman loikan energiatehokkuudessa heti sopimuskauden alussa.”',
              author: 'laatupäällikkö Jukka Lankinen, LOGSTOR Finland',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/logstor-finland-oy-iso-loikka-energiatehokkuudessa',
              linktitle: 'Lue verkossa'
            }
          ];
        this.pageTitleEN = 'Energy audits pave the way';
        this.pageContentsEN =
          [
            {
              paragraph: 'Energy audit supports energy efficiency work in the participating companies and municipalities. Energy audits identify the most cost-effective areas for making savings, as well as concrete means of improving the efficiency of energy use and reducing costs.'
            },
            {
              title: 'What are energy audits?',
              paragraph: 'Energy audits are thorough and comprehensive assessments of the energy and water usage of a building or a production process, as well as the feasible possibilities of making them more efficient. The Ministry of Economic Affairs and Employment (MEAE) subsidizes comprehensive energy audits that are carried out and reported according to MEAE and Motiva’s guidelines.'
            },
            {
              paragraph: 'The Energy Efficiency Act, connected to EED implementation in Finland, entered into force in the beginning of 2015. The law obliges all large companies to carry out mandatory energy audit every fourth year.  Therefore, since 5 June 2014, energy aid for energy audits is no longer granted for large companies.'
            },
            {
              paragraph: 'In 2008–2016, companies and communities participating the Energy Efficiency Agreements for industries, municipal, and property and building sectors have been granted energy audit subsidies a total of €12.9 million. During the agreement period 2008–2016 altogether 2,563 government subsidized energy audits were started.'
            },
            {
              paragraph: 'Mandatory energy audit requirement in the EU Energy Efficiency Directive caused the substantial decrease in the number of started audits.'
            },
            {
              image: '../../assets/images/ETS-energiakatselmusten-ja-tuen-maara-03.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'A high number of energy audits were supported by Finland until 2015. Since the implementation of the Energy Efficiency Directive started on 5 June 2014, large companies are no longer able to apply for energy audit subsidies, which is reflected in a sharp decline in the number of initiated audits and the amount of subsidies granted.'
            },
            {
              paragraph: 'In the municipal sector, which is not subject to mandatory energy audits, the number of audits has increased steadily throughout the Agreement period.'
            },
            {
              image: '../../assets/images/ETS-teollisuuden-energiakatselmoitu-energiankaytto-04.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'In industry majority of all energy audits, approx. 90 percent, have been linked to be the agreement scheme during the agreement period 2008-2016. In 2016, final energy consumption in industry was approximately 136 TWh in Finland. Mainly the energy used in industry has been subject to energy audits at least once.'
            },
            {
              image: '../../assets/images/ETS-palvelualan-energiakatselmointi-tilavuus-05.svg',
              backgroundGradient: 'linear-gradient(#27ad5f, #2b3d4f)'
            },
            {
              paragraph: 'At the end of 2016, over 60 percent of the building volume in the services sector has undergone an energy audit at least once. During 2008-2016 in the private service sector, under half of the audits were carried out in companies signed up to the Energy Effiency Agreement Scheme. In municipal sector the number is higher, about 95 per cent.'
            },
            {
              quote: '"The energy audit provided an excellent basis for practical energy savings measures. The greatest potential for improving energy efficiency was found in the utilisation of waste heat from the production process. We invested in heat pumps right after audit. In this way, we took our biggest leap in energy efficiency right at the start of the Agreement period."',
              author: 'Quality Control Manager Jukka Lankinen, LOGSTOR Finland'
            }
          ];
        break;
      case 'johtaminen-vie-eteenpain':
        this.backgroundGradient = 'linear-gradient(#f0c40f, #ff604c)';
        this.pageTitle = 'Johtaminen vie eteenpäin';
        this.pageContents =
          [
            {
              paragraph: 'Kokemus aiemmalta sopimuskaudelta oli osoittanut, että johdon tuki oli olennainen osa onnistumista, tavoitteen saavuttamista ja toiminnan kehittymistä. Tästä syystä laatu- ja ympäristöjohtamisesta tuttu jatkuvan parantamisen toimintamalli haluttiin juurruttaa osaksi sopimuksia. Energiatehokkuuden seuraaminen ja parantaminen haluttiin muuttaa yksittäisistä projekteista pidempiaikaiseksi ja tavoitteellisemmaksi prosessiksi. Energiavaltaisen teollisuuden ja energiantuotannon yritykset velvoitettiin ottamaan käyttöön energiatehokkuusjärjestelmä ETJ tai liittämään energiatehokkuus osaksi käytössä olevia johtamis- ja ympäristöjärjestelmiä. Pienillä ja keskisuurilla energiankäyttäjillä jatkuvan parantamisen elementit sisällytettiin sopimuksiin.'
            },
            {
              paragraph: 'Lähes 95 prosenttia energiavaltaisen teollisuuden ja 80 prosenttia energiantuotannon toimipaikoista oli sisällyttänyt energiatehokkuuden johtamis- tai ympäristöjärjestelmään. Kaikkiin sopimuksiin liittyneille oli asetettu jatkuvaan parantamiseen liittyviä velvoitteita, joiden toimeenpanosta ne raportoivat vuosittain.'
            },
            {
              title: 'ETJ',
              paragraph: 'Energiatehokkuusjärjestelmä (ETJ) on Suomessa käytössä oleva energiatehokkuuden johtamisjärjestelmä, joka kehitettiin alun perin energiatehokkuussopimukseen liittyneille energiavaltaisen teollisuuden ja energiantuotannon yrityksille. Järjestelmä auttaa yritystä luomaan systemaattisen menettelyn energiatehokkuuden jatkuvaan parantamiseen sekä energiankulutuksen seurantaan ja kustannusten pienentämiseen. ETJ noudattaa energianhallintastandardin ISO 50001 rakennetta, mutta sen vaatimukset on kuvattu yleisemmällä tasolla.'
            },
            {
              title: 'ETJ+',
              paragraph: 'Vuonna 2014 käyttöön otettu kansallinen energianhallintajärjestelmä ETJ+ on sisällöltään ETJ:tä yksityiskohtaisempi ja vaativampi. Energiatehokkuussopimukseen liittyneessä yrityksessä ETJ+ käyttöönoton katsotaan täyttävän energiatehokkuuslain mukaisen suuren yrityksen pakollisen energiakatselmuksen vaatimukset. ETJ+ on mahdollista sertifioida.'
            },
            {
              image: '../../assets/images/ETS-toimipaikat-08.svg',
              backgroundGradient: 'linear-gradient(#f0c40f, #ff604c)'
            },
            {
              title: 'Tässä onnistuimme:'
            },
            {
              smalltitle: 'Energiatehokkuuden jatkuva parantaminen',
              paragraph: 'Yksi keskeisimmistä tavoitteista sopimuskaudella 2008-2016 oli saada liittyjät omaksumaan, että energian tehokas käyttö ei ole yksittäinen projekti, vaan prosessi.'
            },
            {
              paragraph: 'Sopimustoiminta on luonut osaltaan tähän sopivan tiukan ja toisaalta riittävän väljän menettelytavan. Toimintasuunnitelmat, vuosittainen raportointi ja energiavaltaisia aloja koskeva velvoite energiatehokkuusjärjestelmän (ETJ) käyttöönotosta ovat olleet mukana juurruttamassa energiatehokkuutta osaksi johtamista ja arkea.'
            },
            {
              quote: '”Sopimuskauden ehdottomasti suurin saavutus oli kaikkien konsernin liiketoimintojen ja tehtaiden henkilöstön sitoutuminen määrätietoiseen ja pitkäjänteiseen energiatehokkuustyöhön. Noin puolet energiankäytön tehostamisesta on syntynyt prosessien analysoinnilla ja kehittämisellä, loput laiteinvestoinneilla.”',
              author: 'energiajohtaja Ilkka Latvala, Metsä Group',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/metsa-group-henkilosto-sitoutuu-energiatehokkuuteen',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Energiatehokkuuden parantaminen on tuonut konsernille selkeää taloudellista hyötyä. Myös maine ympäristövastuun tuntevana yrityksenä on vahvistunut. Käytössä oleva Energiatehokkuusjärjestelmä ETJ+ on hyvä työkalu energiatehokkuuden jatkuvaan parantamiseen ja systemaattinen tapa hakea energiansäästökohteita.”',
              author: 'projektipäällikkö Samuli Toivanen, Sucros Oy',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/sucros-oy-energiansaasto-onnistui-yli-odotusten',
              linktitle: 'Lue verkossa'
            }
          ];
        this.pageTitleEN = 'Going forward with management';
        this.pageContentsEN =
          [
            {
              paragraph: 'Experience from the previous Agreement period had shown that management support was an essential part of success, achievement of objectives and development of activities. For this reason, there was a desire to include the continuous improvement model, which is well-known in quality and environmental management, as part of the Agreements. Aim was to incorporate monitoring and improvement of energy efficiency in a longer-term and more goal-oriented process, rather than to only carry out individual projects. Energy intensive industries and energy production companies were obliged to introduce an Energy Efficiency System (EES) or to integrate energy efficiency into their existing management systems. For small and medium energy users, elements of continuous improvement were included in the Agreements.'
            },
            {
              paragraph: 'Almost 95 percent of energy intensive industry and 80 percent of energy production sites had included energy efficiency in their management systems by the end of 2016. All agreement participants were subject to continuous improvement requirements, the implementation of which they reported annually.'
            },
            {
              title: 'EES',
              paragraph: 'The Energy Efficiency System (EES) is an energy management system used in Finland.  It was initially developed for energy-intensive industries and energy production companies that participated in the Energy Efficiency Agreement. The system helps the company to create a systematic process for continuous improvement of energy efficiency as well as for monitoring energy consumption and reducing energy costs. EES complies with the structure of ISO 50001 Energy Management Standard, but its requirements are described more generally.'
            },
            {
              title: 'EES+',
              paragraph: 'The national Energy Efficiency System+ (EES+), which was introduced in 2014, is more detailed and demanding than the EES. For companies that participate in the Energy Efficiency Agreement, the implementation of the EES+ is considered to meet the requirements of the mandatory energy audit of a large company under the Energy Efficiency Act. It is possible to certify an EES+.'
            },
            {
              image: '../../assets/images/ETS-toimipaikat-08.svg',
              backgroundGradient: 'linear-gradient(#f0c40f, #ff604c)'
            },
            {
              title: 'In this we succeeded:'
            },
            {
              smalltitle: 'Continuous improvement of energy efficiency',
              paragraph: 'One of the main targets of the 2008-2016 Agreement period was to get the participating companies and municipalities to acknowledge that the efficient use of energy is not a single project, but a process.'
            },
            {
              paragraph: 'The Agreements have offered a suitably strict and, yet a sufficiently flexible procedure.  Agreement obligations – action plans, annual reporting, and introduction of the Energy Efficiency'
            },
            {
              quote: '"The undoubtedly greatest achievement of the Agreement period was getting all of the corporation’s business operations and the staff of the factories to commit to determined and long-term energy efficiency work. About half of the enhanced energy use has been generated through process analysis and development, and the rest with investments."',
              author: 'Energy Director Ilkka Latvala, Metsä Group'
            },
            {
              quote: '"Improving energy efficiency has brought the corporation clear economic benefits. Also, the reputation as an environmentally responsible company has gained strength. The current Energy Efficiency System EES+ is a good tool for continuously improving energy efficiency and a systematic way to find energy savings measures.”',
              author: 'Project Manager Samuli Toivanen, Sucros Oy'
            }
          ];
        break;
      case 'opastusta-ja-neuvontaa-kayttajille':
        this.backgroundGradient = 'linear-gradient(#cf3887, #e67d21)';
        this.pageTitle = 'Opastusta ja neuvontaa käyttäjille';
        this.pageContents =
          [
            {
              paragraph: 'Energiatehokkuussopimuksiin liittyneet energia-alan ja öljyalan yritykset sitoutuvat omaan energiankäyttöön liittyvien toimien lisäksi neuvomaan asiakkaitaan energian tehokkaammassa käytössä.'
            },
            {
              paragraph: 'Energia-alan yritykset tarjosivat asiakkaille energiatehokkuusneuvontaa muun muassa palvelupisteissä, puhelimitse, sähköpostitse, erilaisissa sidosryhmätilaisuuksissa sekä verkkosivuilla. Neuvonta yrityksissä on ollut aktiivista ja tavoittanut valtaosan niiden asiakaskunnasta. Lisäksi yhtiöt viestivät energiansäästöstä aktiivisesti asiakaslehdissään. Lehdet tavoittavat lähes kaikki suomalaiset kotitaloudet useita kertoja vuodessa.'
            },
            {
              paragraph: 'Öljyalan HÖYLÄ III sopimukseen liittyneiden yritysten sopimuksen mukainen asiakasneuvonta painottui öljylämmittäjiin, joita kannustettiin uusimaan vanhat kattilat energiatehokkaisiin, huolehtimaan lämmitysjärjestelmän säännöllisestä tarkistuksesta ja kunnossapidosta sekä ottamaan öljyn rinnalla käyttöön uusiutuvaa energiaa.'
            },
            {
              paragraph: 'Myös kiinteistöalan vuokra-asuinkiinteistöjen toimenpideohjelmassa asukkaita opastettiin energiankäytön tehostamismahdollisuuksista ja merkityksestä ja toimitilakiinteistöjen toimenpideohjelmassa vastaavaa neuvontaa kohdistettiin toimitilojen vuokralaisiin. Lisäksi toimitilakiinteistöjen toimenpideohjelmaan liittyneiden edellytettiin ottavan sopimuksen tavoitteet huomioon kiinteistönhoitopalveluja tarjoavien yritysten kanssa tehtävissä sopimuksissa.'
            },
            {
              image: '../../assets/images/ets-opastusta-ja-neuvontaa-02.svg',
              backgroundGradient: 'linear-gradient(#cf3887, #e67d21)'
            },
            {
              smalltitle: 'Neuvonnalla on suuri merkitys',
              paragraph: 'Vuonna 2016 energia-alan ja öljyalan asiakaspään kattavan neuvonnan arvioitiin tehostaneen loppukäyttäjien energiankäyttöä yhteensä noin yhdellä terawattitunnilla.'
            },
            {
              quote: '”Asukkaiden rooli on energiasäästöasioissa merkittävä. Viestintä on tärkeää, jotta saamme asukkaat mukaan. Yksi keskeinen kanava on kaikkiin asuntoihin jaettava asiakaslehti, jossa kerrotaan säännöllisesti energia-asioista ja annetaan käytännön vinkkejä energian säästämiseen. Keräämme myös yhteistyökumppaneilta ja asukkailta ehdotuksia ja ideoita, joilla energiaa voidaan säästää.”',
              author: 'talotekniikkainsinööri Untamo Aukio, Espoon Asunnot',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/espoon-asunnot-oy-jarjestelmallinen-ote-kannattaa-energiansaastossa',
              linktitle: 'Lue verkossa'
            },
            {
              quote: '”Kuluttajat ovat entistä kiinnostuneempia kustannuksia ja ympäristöä säästävistä energiaratkaisuista. Eniten tietoa halutaan arkisista asioista, kuten energiatehokkaasta lämmityksestä, valaistuksesta ja sähkölaitteiden järkevästä käytöstä. Viime vuosina uusiutuva energia, etenkin aurinkosähkö, on herättänyt valtavaa kiinnostusta. Ihmiset kyselevät fiksuista hyödyntämistavoista ja pyytävät neuvoja laitehankintoihin.”',
              author: 'energiapäällikkö Raimo Prusi, Sallila Energia',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/sallila-energia-oy-asiakkaat-innostuivat-energiatehokkuudesta',
              linktitle: 'Lue verkossa'
            }
          ];
        this.pageTitleEN = 'Guidance and advice for users';
        this.pageContentsEN =
          [
            {
              paragraph: 'In addition to improve efficiency of their own energy use, energy distribution and retail companies which had joined the Energy Efficiency Agreements were committed to provide energy advice also to their final customers.'
            },
            {
              paragraph: 'Energy distribution and retail companies provided advice to their customers at their own service points, by phone, email, at various stakeholder events and on their websites. Advice was provided actively by the participated companies and it reached the majority of their customers. Companies also distributed informative material with energy-saving content to their customers and provided schools with free teaching materials. They have also been active in promoting energy savings in their customer magazines, which are reaching almost all Finnish households several times a year.'
            },
            {
              paragraph: 'Also in the implementation of the property and building sector’s action plan for rental housing, residents were guided in the possibilities and significance of efficient energy use; and correspondingly implementation of the action plan for commercial properties required guidance to tenants. In addition, participants of the Commercial Property Action Plan were required to take into account the objectives of the action plan in their contracts with companies that provide property management services.'
            },
            {
              image: '../../assets/images/ets-opastusta-ja-neuvontaa-02.svg',
              backgroundGradient: 'linear-gradient(#cf3887, #e67d21)'
            },
            {
              smalltitle: 'Energy advice plays a remarkable role',
              paragraph: 'At the end of 2016, advisory services were assessed to generate approx. 1 TWh annual additional savings in customer’s energy use.'
            },
            {
              quote: '"Residents have a significant role in energy saving issues. Communication is important so that we can involve the residents. A central channel is the customer magazine which is distributed to all homes, which regularly informs about energy issues and provides practical tips on saving energy. We also collect energy savings proposals and ideas from partners and residents."',
              author: 'Building Engineer Untamo Aukio, Espoon Asunnot'
            },
            {
              quote: '"Consumers are becoming more interested in cost savings and environmentally friendly energy solutions. The greatest interest is in information about everyday things, such as energy efficient heating, lighting and the responsible use of electrical equipment. In recent years, renewable energy, especially solar energy, has attracted great interest. People are asking about smart energy use measures and for advice on equipment purchases."',
              author: 'Energy Manager Raimo Prusi, Sallila Energia'
            },
            {
              quote: '"Nearly all our residential properties are connected to remote monitoring, which gives an accurate picture of energy and water consumption. This way we can focus energy savings measures to reduce the consumption. With simple control measures and temperature control we can achieve great savings. Real time monitoring and adjustment of heating also improves the level of comfort in living."',
              author: 'Unit manager Kimmo Rintala, Kojamo Oyj'
            }
          ];
        break;
      case 'elinkeinoelama':
        this.backgroundGradient = 'linear-gradient(#3497db, #9b58b6)';
        this.pageTitle = 'Elinkeinoelämä';
        this.pageContents =
          [
            {
              paragraph: 'Elinkeinoelämän energiatehokkuussopimuksessa oli vuosina 2008-2016 mukana 586 yritystä ja niiden 3 914 toimipaikkaa.'
            },
            {
              image: '../../assets/images/ets-pallot-elinkeinoelama-01.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              paragraph: 'Yritysten vuosina 2008–2016 toteuttamien energiansäästötoimien ansiosta toiminta on energia- ja kustannustehokkaampaa ja siitä syntyy vähemmän ilmastonmuutosta aiheuttavia hiilidioksidipäästöjä.'
            },
            {
              quote: '"Suomessa yritykset ovat sitoutuneet poikkeuksellisen kattavasti monelta eri toimialalta pitkäjänteiseen ja tavoitteelliseen energiatehokkuustoimintaan. Tässä laajuudessa vastaavaa ei löydy muualta Euroopasta tai maailmalta. Oman energiatehokkuuden parantamisen lisäksi yritykset toimivat samalla myös yhteisen, Suomelle asetetun, tehostamistavoitteen eteen. Jokainen kantaa kortensa kekoon yrityksen koosta tai liiketoiminnan muodosta riippumatta."',
              author: 'asiantuntija Kati Ruohomäki, EK Elinkeinoelämän keskusliitto'
            },
            {
              quote: '"Energiayrityksille on tärkeää, että energiatehokkuutta edistetään yhdessä asiakkaiden ja eri toimijoiden kanssa. Energiankäytön tehostaminen avaa merkittäviä uusia liiketoimintamahdollisuuksia alan yrityksille. Älykkäät energiajärjestelmät yhdessä järjestelmien tuottaman tiedon kanssa mahdollistavat kehittyneempiä palveluita kaikille osapuolille, erityisesti energiankäyttäjille."',
              author: 'Toimitusjohtaja Jukka Leskelä, Energiateollisuus ry'
            },
            {
              quote: '”Vapaaehtoisuuteen perustuvat sopimukset ovat osoittautuneet kaupan alalla erittäin toimivaksi tavaksi tehostaa energiankäyttöä. Olemme tyytyväisiä, että kaupan ala lähti innolla mukaan ilmastotalkoisiin. Tästä on hyvä jatkaa.”',
              author: 'asiantuntija Marja Ola, Kaupan liitto ry'
            }
          ];
        this.pageTitleEN = 'Industries – Industry, energy and service sector';
        this.pageContentsEN =
          [
            {
              paragraph: 'Altogether 586 companies and their 3914 sites had signed up to voluntary Energy Efficiency Agreement for Industries in 2008-2016.'
            },
            {
              image: '../../assets/images/ets-pallot-elinkeinoelama-eng-04.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              paragraph: 'Due to energy saving measures implemented over this period, their businesses are more energy- and cost-efficient and produce less carbon dioxide emissions.'
            },
            {
              quote: '"In Finland, companies from a wide range of sectors have committed, exceptionally comprehensively, to long-term and targeted energy efficiency activities. The equivalent, at such a scale, cannot be found elsewhere in Europe or the world. In addition to improving their own energy efficiency, companies are also at the same time working towards achieving the common energy efficiency targets of Finland. Everyone is taking care of their own part, regardless of the size or type of business."',
              author: 'Senior Adviser Kati Ruohomäki, Confederation of Finnish Industries EK'
            },
            {
              quote: '"For energy companies, it is important that energy efficiency is promoted in partnership with customers and different actors. Enhancing energy efficiency opens significant new business opportunities for companies within the sector. Smart energy systems, together with the information produced by the systems, enable more sophisticated services for all parties, especially the end users of energy."',
              author: 'Managing Director Jukka Leskelä, Finnish Energy Industries'
            },
            {
              quote: '"Voluntary agreements have proven to be a very effective way of enhancing energy use in the commerce sector. We are pleased that the commerce sector so eagerly agreed to join the communal work for mitigating climate change. From here it is good to continue."',
              author: 'Senior Adviser Marja Ola, The Federation of Finnish Commerce'
            }
          ];
        break;
      case 'kiinteistoala':
        this.backgroundGradient = 'linear-gradient(#cf3887, #9b58b6)';
        this.pageTitle = 'Kiinteistöala';
        this.pageContents =
          [
            {
              paragraph: 'Kiinteistöalan energiatehokkuussopimuksessa oli vuosina 2008-2016 mukana 75 yritystä ja yhteisöä ja niiden 1032 toimipaikkaa sekä yli 220 000 vuokra-asuntoa.'
            },
            {
              image: '../../assets/images/ets-pallot-kiinteistoala-01.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              paragraph: 'Liittyneiden vuosina 2008–2016 toteuttamien energiatehokkuustoimien ansiosta toiminta on energia- ja kustannustehokkaampaa ja siitä syntyy vähemmän ilmastonmuutosta aiheuttavia hiilidioksidipäästöjä.'
            },
            {
              quote: '”Energiatehokkuussopimuksen saavutukset ovat osoitus siitä, että yhteistyössä ja pitkäjänteisesti kehittäen voidaan ottaa merkittäviä edistysaskeleita. Kiinteistöala on yksi esimerkillisimmistä toimialoista energiatehokkuustalkoissa, ja on hienoa, että vapaaehtoisin voimin on päästy näin mittaviin tuloksiin. Uskomme, että seuraava kausi tulee olemaan yhtä menestyksekäs.”',
              author: 'Johtaja – asunnot, Aija Tasa, RAKLI ry'
            },
            {
              quote: '”Lähes kaikki asuinkiinteistöt on liitetty etäseurantaan, joka antaa tarkan kuvan energian ja veden kulutuksesta. Näin pystymme kohdentamaan kulutusta pienentäviä toimenpiteitä. Yksinkertaisillakin säätötoimenpiteillä ja lämpötilan hallinnalla saavutetaan isoja säästöjä. Lämmityksen reaaliaikainen seuranta ja säätäminen parantavat myös asumismukavuutta.”',
              author: 'yksikön johtaja Kimmo Rintala, Kojamo Oyj',
              link: 'http://www.energiatehokkuussopimukset2017-2025.fi/ajankohtaista/vvo-esineiden-internet-auttaa-energiansaastossa',
              linktitle: 'Lue verkossa'
            }
          ];
        this.pageTitleEN = 'Property and Building Sector';
        this.pageContentsEN =
          [
            {
              paragraph: 'Altogether 75 companies with 1,032 commercial properties and over 220,000 rental apartments took part in the Property and Building Sector Energy Efficiency Agreement in 2010-2016.'
            },
            {
              image: '../../assets/images/ets-pallot-kiinteistoala-eng-04.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              paragraph: 'Due to energy saving measures implemented over this period, their businesses are more energy- and cost-efficient and produce less carbon dioxide emissions.'
            },
            {
              quote: '"The achievements of the Energy Efficiency Agreements are an indication that through co-operation and long-term development significant progress can be made. The property and building sector is one of the most exemplary sectors in the joint energy efficiency work, and it is great that such substantial results have been achieved through voluntary efforts. We believe that the next period will be just as successful."',
              author: 'Director - Housing properties, Aija Tasa, RAKLI - The Finnish Association of Building Owners and Construction Clients'
            },
            {
              quote: '"Nearly all our residential properties are connected to remote monitoring, which gives an accurate picture of energy and water consumption. This way we can focus on measures that target reductions in energy consumption. With simple control measures and temperature control we can achieve great savings. Real time monitoring and adjustment of heating also improves the comfort in living."',
              author: 'Unit manager Kimmo Rintala, Kojamo Oyj'
            }
          ];
        break;
      case 'kunta-ala':
        this.backgroundGradient = 'linear-gradient(#f0c40f, #cf3887)';
        this.pageTitle = 'Kunta-ala';
        this.pageContents =
          [
            {
              paragraph: 'Kunta-alan energiatehokkuussopimuksessa ja energiaohjelmassa oli vuosina 2008–2016 mukana yhteensä 117 kuntaa ja 15 kuntayhtymää.'
            },
            {
              paragraph: 'Liittyneiden vuosina 2008–2016 toteuttamien energiatehokkuustoimien ansiosta kuntien ja kuntayhtymien toiminta on energia- ja kustannustehokkaampaa ja siitä syntyy vähemmän ilmastonmuutosta aiheuttavia hiilidioksidipäästöjä.'
            },
            {
              image: '../../assets/images/ets-pallot-kunta-ala-03.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              paragraph: 'Liittyneiden vuosina 2008–2016 toteuttamien energiatehokkuustoimien ansiosta toiminta on energia- ja kustannustehokkaampaa ja siitä syntyy vähemmän ilmastonmuutosta aiheuttavia hiilidioksidipäästöjä.'
            },
            {
              quote: '”Riihimäen kaupungille energia- ja ilmastotyö on äärimmäisen tärkeää. Energiatehokkuus on keskeinen osa modernin kaupungin toimintaa. On pyrittävä löytämään ympäristön kannalta keskeisiä tapoja säästää energiakustannuksia ja vapauttamaan resursseja tärkeämpään käyttöön. Sopimus on tarjonnut meille loistavan työkalun verrata kiinteistöjen ja toimintojen nykytilaa ja arvioida, mikä tulevaisuudessa on mahdollista ja millä keinoin.”',
              author: 'kaupunginjohtaja Sami Sulkko, Riihimäen kaupunki',
              link: 'https://youtu.be/yyAUlfqcUH8',
              linktitle: 'Lue video'
            },
            {
              quote: '”Kunnat ja kuntayhtymät itse ovat merkittäviä energiakäyttäjiä ja voivat vaikuttaa oman toimintansa energiatehokkuuteen. Kunnat voivat toimia yhteiskuntavastuun etulinjassa omassa paikallisyhteisössä ja vaikuttaa paikallisten toimijoiden tietoisuuteen ja aktiivisuuteen energiatehokkuuden rintamalla. Energiatehokkuussopimukset ovat hyvä, konkreettinen työväline ja kirittäjä kuntien toiminnassa.”',
              author: 'Varatoimitusjohtaja Timo Reina, Suomen kuntaliitto'
            },
          ];
        this.pageTitleEN = 'Municipal sector';
        this.pageContentsEN =
          [
            {
              paragraph: 'Altogether 117 municipalities and 15 joint municipalities took part in the Finnish municipalities’ energy efficiency agreement and energy programme in 2008-2016.'
            },
            {
              paragraph: 'Due to energy saving measures implemented in these municipalities and joint municipalities in 2008–2016 their activities are more energy- and cost-efficient and produces less carbon dioxide emissions.'
            },
            {
              image: '../../assets/images/ets-pallot-kunta-ala-eng-04.svg',
              backgroundGradient: 'linear-gradient(#f5f5f580, #e6e6e6)'
            },
            {
              quote: '”Energy and climate work is of extreme importance for the City of Riihimäki. Energy efficiency is a central part of the activities of a modern city. It is important to find ways that take into account the environment and save energy costs and thus release resources for more important uses. The Agreement has provided us with a great tool for comparing the current state of properties and sites and to assess what is possible in the future and by what means.”',
              author: 'Mayor Sami Sulkko, City of Riihimäki'
            },
            {
              quote: '"Municipalities and joint municipalities are major energy users and can influence the energy efficiency of their own activities. Municipalities can act in the forefront of social responsibility in their own local cooperation and influence the awareness and activeness of local actors on the energy efficiency front. Energy Efficiency Agreements are a good, concrete tool and a motivator for municipal activities."',
              author: 'Deputy Managing Director Timo Reina, Association of Finnish Local and Regional Authorities'
            },
          ];
        break;
      case 'oljyala':
        this.backgroundGradient = 'linear-gradient(#27ad5f, #f0c40f)';
        this.pageTitle = 'Öljyala';
        this.pageContents =
          [
            {
              paragraph: 'Öljyalan energiatehokkuussopimuksen HÖYLÄ III 2008-2016 toimeenpanoon osallistuivat kaikki Suomessa toimivat lämmitys- ja liikennepolttonesteitä toimittavat yhtiöt.'
            },
            {
              paragraph: 'Lämmitys- ja liikennepolttonesteiden jakelutoiminnan energiatehokkuussopimus HÖYLÄ III -sopimus kattoi kaudella 2008-2016 öljylämmitteiset kiinteistöt ja liikennepolttonesteiden jakelutoiminnan. Sopimuksen tavoite oli lämmitys- ja liikennepolttonesteiden käytön energiatehokkuuden parantaminen ja uusiutuvien energiamuotojen käytön lisääminen. Sopimus palveli sekä energiapalveludirektiivin (ESD), että 2012 lähtien energiatehokkuusdirektiivin (EED) energiansäästötavoitteiden saavuttamista. Lisäksi öljylämmityskiinteistöjen osalta sopimus palveli rakennusten energiatehokkuusdirektiivin (EPBD) edellyttämien lämmitysjärjestelmätarkastusten vaihtoehtoista toimeenpanoa neuvontamenettelyllä.'
            },
            {
              paragraph: 'Kaikkiaan sopimuskaudella 2008-2016 öljylämmityskiinteistöihin toteutettiin noin 25 000 kattilavaihtoa. Niiden vuotuinen energiansäästö vuoden 2016 lopussa oli arviolta yhteensä 0,26 TWh. Lisäksi öljylämmitysjärjestelmien polttimien vaihdolla, säätölaitteiden uusimisella sekä öljylämmitteisten kiinteistöjen rakenteiden energiatehokkuuden parantamisella säästettiin vuosittain energiaa yhteensä noin 0,15 TWh vuoden 2016 loppuun mennessä.'
            },
            {
              paragraph: 'Säännöllisen neuvonnan ja viestinnän vuotuinen säästövaikutus oli vuonna 2016 arviolta 0,1 TWh. Tärkeitä viestintäkanavia olivat oljylammitys.fi-sivusto ja Lämmöllä-lehti, joka postitetaan kolmesti vuodessa kaikkiin öljylämmitteisiin pientaloihin, joita on Suomessa 150 000.',
              link: 'http://www.oljylammitys.fi',
              linktitle: 'Lue lisää'
            },
            {
              quote: '”Öljyalan sopimus Höylä III jatkoi onnistuneesti eteenpäin aiempien energiatehokkuussopimusten aikana aloitettua työtä. Öljylämmittäjät ovat toteuttaneet erilaisia energiatehokkuustoimia ja lisänneet uusiutuvan energian käyttöä, jolloin lämmitysöljyn kulutus on selvästi vähentynyt.”',
              author: 'varatoimitusjohtaja Pekka Huttula, Öljy- ja biopolttoaineala ry'
            },
            {
              quote: '”Yhdessä öljy-alan toimijoiden kanssa olemme pystyneet toteuttamaan direktiivien vaatimukset öljylämmityskiinteistöjen osalta tavalla, joka on toimiva asukkaiden, ympäristön ja kansantalouden kannalta.”',
              author: 'ympäristöneuvos Maarit Haakana, ympäristöministeriö'
            },
          ];
        this.pageTitleEN = 'Oil sector';
        this.pageContentsEN =
          [
            {
              paragraph: 'All companies involved in the distribution of liquid heating and transport fuels in Finland participated in the implementation of the Energy Efficiency Agreement for Oil Sector HÖYLÄ III 2008-2016.'
            },
            {
              paragraph: 'The Energy Efficiency Agreement for distribution of liquid heating and transport fuels, HÖYLÄ III, covered during 2008-2016 oil heated buildings and the distribution of transport fuels. The objective of the Agreement was to improve the energy efficiency and increase the use of renewable energy forms in heating and transport fuels. The Agreement served the reaching of the energy efficiency targets of both the Energy Services Directive (ESD) and, as of 2012, the Energy Efficiency Directive (EED), and also the alternative implementation of boiler inspections, by means of an advisory procedure, as required by the Energy Performance of Buildings Directive (EPBD).'
            },
            {
              paragraph: 'Altogether, about 25,000 boiler replacements were made in oil heated properties during the Agreement period 2008-2016. Their estimated annual energy savings totalled 0.26 TWh at the end of 2016. In addition, by replacing boilers in oil heating systems, renewing control equipment and improving the energy efficiency of oil heated property structures, annual energy savings of around 0.15 TWh were made by the end of 2016.'
            },
            {
              paragraph: 'The saving effect of regular advice and communications in 2016 was estimated at 0.1 TWh. Important communication channels were the oljylammitys.fi site and Lämmöllä magazine, which is delivered three times a year to all oil heated houses, of which there are 150,000 in Finland.',
              link: 'http://www.oljylammitys.fi',
              linktitle: 'Read more'
            },
            {
              quote: '"The oil sector Agreement Höylä III successfully continued the work started already during the previous Energy Efficiency Agreements. Various energy efficiency measures have been implemented and the use of renewable energy has increased in oil heaters, meaning that there has been a clear decrease in the use of heating oil."',
              author: 'Deputy Managing Director Pekka Huttula, Finnish Petroleum and Biofuels Association'
            },
            {
              quote: '"Together with companies in the oil sector, we have been able to meet the requirements of the directives for oil-heated buildings in a way that works for the residents, the environment and the economy."',
              author: 'Environment Counsellor Maarit Haakana, The Ministry of the Environment'
            },
          ];
        break;
      case 'muut-sopimusalat':
        this.backgroundGradient = 'linear-gradient(#3497db, #9b58b6)';
        this.pageTitle = 'Muut sopimusalat';
        this.pageContents =
          [
            {
              smalltitle: 'Kutteri-ohjelma – sopimus biokattiloiden energiatehokkuutta parantavasta neuvonnasta',
              paragraph: 'Kutteri-ohjelma on toteuttaa Suomessa bioenergiaa käyttävien lämmitysjärjestelmien osalta neuvontamenettelyä, joka on vaihtoehto rakennusten energiatehokkuusdirektiivin (EPBD) edellyttämille lakisääteisille lämmitysjärjestelmätarkastuksille. Sopimus luo edellytykset bioenergialämmitysjärjestelmien käyttöön ja huoltoon liittyvälle neuvonnalle ja opastukselle. Neuvonta koskee kaikkia alle 1 megawatin biokattiloita. Vastaava vaihtoehtoinen öljylämmitysjärjestelmiä koskeva neuvontamenettely sisältyy Höylä-sopimuksen toimeenpanoon.'
            },
            {
              paragraph: 'Vuosina 2014–2016 sopimuksen osapuolia olivat ympäristöministeriö Bioenergia ry, Ariterm Oy, Nuohousalan Keskusliitto ry, Lämmitysenergia Yhdistys ry, Suomen Omakotiliitto ry, Hämeen ammattikorkeakoulu ja Jyväskylän ammattikorkeakoulu ja Motiva Oy.'
            },
            {
              smalltitle: 'Maatalouden energiaohjelma',
              paragraph: 'Maa- ja metsätalousministeriön vastuulla ollut maatalouden energiaohjelma käynnistyi vuonna 2010. Sen korvasi vuoden 2016 syksyllä allekirjoitettu Maatalous- ja puutarhasektorin energiatehokkuustoimia koskeva toimialasopimus vuosille 2016–2020.'
            },
            {
              paragraph: 'Ohjelman osapuolia olivat maa-ja metsätalousministeriö, Maa- ja metsätaloustuottajain Keskusliitto MTK ry, Puutarhaliitto ry, Svenska lantbruksproducenternas centralförbund SLC ja Kauppapuutarhaliitto ry.'
            },
            {
              smalltitle: 'Liikenteen energiatehokkuussopimukset',
              paragraph: 'Liikenteelle solmittiin kaudelle 2008–2016 kaksi liikenne ja viestintäministeriön vastuulla ollutta energiatehokkuussopimusta: tavaraliikenteen ja logistiikan energiatehokkuussopimus ja joukkoliikenteen energiatehokkuussopimus. Sopimusten toimeenpano päättyi vuonna 2015 ja ne korvattiin Trafin ylläpitämällä Tieliikenteen kuljetusyritysten vastuullisuusmallilla.'
            },
            {
              paragraph: 'Sopimusten osapuolia olivat liikenne- ja viestintäministeriö (LVM), työ- ja elinkeinoministeriö (TEM), ympäristöministeriö (YM), Liikenteen turvallisuusvirasto Trafi, Suomen Kuljetus ja Logistiikka SKAL ry ja sen jäsenyhdistykset (SKAL), Logistiikkayritysten Liitto (LL), VR Yhtymä Oy (VR), Linja-autoliitto ry (LAL) sekä Suomen Paikallisliikenneliitto ry (PLL). '
            },
          ];
        this.pageTitleEN = 'Other agreement sectors';
        this.pageContentsEN =
          [
            {
              smalltitle: 'Kutteri Programme - Agreement advising on improving the energy efficiency of bio boilers',
              paragraph: 'The Kutteri programme has been developed for the implementation of an alternative advisory procedure for bio boiler inspections in Finland as required by the Energy Performance of Buildings Directive (EPBD). The Agreement stipulates the conditions for providing advice and guidance in the use and maintenance of bioenergy heating systems. The advice applies to all less than 1 megawatt bio boilers. A similar alternative advisory procedure for oil boilers is included in the Höylä Agreement.'
            },
            {
              paragraph: 'During 2014-2016, parties to the Agreement were the Ministry of the Environment, the Bioenergy Association of Finland, Ariterm Oy, Keskusliitto Nuohousalan ry (central association of Finnish chimney sweepers), Lämmitysenergia Yhdistys ry (association of heating energy), Suomen Omakotiliitto ry (association of Finnish single-family houses), Häme University of Applied Sciences, Jyväskylä University of Applied Sciences and Motiva Oy.'
            },
            {
              smalltitle: 'Farm Energy Programme',
              paragraph: 'The Farm Energy Programme, led by the Ministry of Agriculture and Forestry, was launched in 2010. It was replaced in 2016 by an energy efficiency programme for the agricultural and gardening sectors that covers the period 2016-2020.'
            },
            {
              paragraph: 'The parties of the Programme were the Ministry of Agriculture and Forestry, Central Union of Agricultural Producers and Forest Owners, Puutarhaliitto ry (garden association), Central Union of Swedish-Speaking Agricultural Producers in Finland, and Kauppapuutarhaliitto ry (Finnish Glasshouse Growers’ Association).'
            },
            {
              smalltitle: 'Energy Efficiency Agreements for the transport sector',
              paragraph: 'There were two Energy Efficiency Agreements for the transport sector for the period 2008-2016, under the responsibility of the Ministry of Transport and Communications: the Goods Transport and Logistics Energy Efficiency Agreement and the Public Transport Energy Efficiency Agreement. The implementation of the Agreements terminated in 2015 and they were replaced by the responsibility model for road transport enterprises, which is maintained by the Finnish Transport Safety Agency (Trafi).'
            },
            {
              paragraph: 'The parties to the Agreements were the Ministry of Transport and Communications, the Ministry of Economic Affairs and Employment, the Ministry of the Environment, Finnish Transport and Logistics and its member organizations, Logistiikkayritysten Liitto (Association of Logistic Enterprises in Finland), VR Group, Finnish Bus and Coach Association, and Suomen Paikallisliikenneliitto ry (Finnish Public Transport Association).'
            },
          ];
        break;
      case 'sopimuksiin-iittyneet':
        this.backgroundGradient = 'linear-gradient(#f0c40f, #ff604c)';
        this.pageTitle = 'Sopimuksiin liittyneet';
        this.pageContents =
          [
            {
              title: 'Elinkeinoelämän energiatehokkuussopimus 2008-2016 liittyneet'
            },
            {
              smalltitle: 'Energiavaltaisen teollisuuden toimenpideohjelma',
            },
            {
              list: [
                'AGA Oy Ab',
                'Akzo Nobel Finland Oy',
                'Boliden Harjavalta Oy',
                'Boliden Kokkola Oy',
                'Borealis Polymers Oy',
                'Corenso United Oy Ltd',
                'CP Kelco Oy',
                'Finnfeeds Finland Oy',
                'Finnsementti Oy',
                'Freeport Cobalt Oy',
                'Gasum Oy',
                'Genencor International Oy',
                'Huntsman Pigments and Additives',
                'Kemira Oyj',
                'Koskisen Oy',
                'Kotkamills Oy',
                'Luvata Pori Oy',
                'Metsä Board Oyj',
                'Metsä Fibre Oy (ent. Metsä Botnia)',
                'Metsä Tissue Corp.',
                'Mondo Minerals BV Branch Finland',
                'Neste Oyj',
                'Nokian Renkaat Oyj',
                'Nordkalk Oy Ab',
                'Norilsk Nickel Harjavalta Oy',
                'Outokumpu Oyj',
                'Ovako Bar Oy Ab',
                'Pankaboard Oy',
                'Paroc Oy Ab',
                'Raisio konserni',
                'Rautaruukki Oyj',
                'Sappi Finland I Oy',
                'Savon Sellu Oy',
                'Solvay Chemicals Finland Oy',
                'Stora Enso Oyj',
                'Sucros konserni',
                'Suominen Kuitukankaat Oy',
                'Taminco Finland Oy',
                'Tervakoski Oy',
                'UPM-Kymmene Oyj',
                'Yara Suomi Oy'
              ]
            },
            {
              smalltitle: 'Elintarviketeollisuuden toimenpideohjelma'
            },
            {
              list: [
                'Altia Oyj',
                'Apetit Oyj',
                'Arla Oy',
                'Atria Suomi Oyj',
                'Eckes-Granini Finland Oy Ab',
                'Fazer Leipomot Oy',
                'Fazer Makeiset Oy',
                'Findest Protein Oy',
                'Gustav Paulig Oy Ab',
                'Halva Oy Ab',
                'Hartwall Oy Ab',
                'HKScan Finland Oy',
                'Honkajoki Oy',
                'Hämeenlinnan Osuusmeijeri',
                'Juustoportti Food Oy',
                'Kotivara Oy',
                'Kymppi-Maukkaat Oy',
                'Laihian Mallas Oy',
                'Laitilan Wirvoitusjuomatehdas',
                'Lankoski Oy',
                'Lantmännen Unibake Ab Finland Oy',
                'Leipomo ja konditoria Nurmi & Sulonen Oy',
                'Liisan Leipomo Oy',
                'Linkosuon Leipomo Oy',
                'Lunden Oy Ab Jalostaja',
                'MP-Maustepalvelu Oy',
                'Mush Oy Ltd',
                'Olvi Oyj',
                'Osuuskunta Satamaito',
                'Oy Emilsberg Ab',
                'Paisto-Mestari Oy',
                'Panda Oy Ab',
                'Pernod Ricard Finland Oy',
                'Pirjon Pakari Ky',
                'Pohjolan Peruna Oy',
                'Polarica Oy',
                'Polttimo Oy',
                'Saarioinen Oy',
                'Sinebrychoff Oy Ab',
                'Snellmannin Kokkikartano Oy',
                'Snellmans Köttförädling Ab',
                'Toripiha Oy',
                'Valio Oy',
                'Veljekset Mattila Oy',
                'Veraisen Leipomo Oy',
                'Wursti Oy J & J',
                'Yrjö Wigren Oy'
              ]
            },
            {
              smalltitle: 'Kemianteollisuuden toimenpideohjelma',
            },
            {
              list: [
                'Akkuser Oy',
                'Arizona Chemical Oy',
                'Arwina Oy',
                'Ashland Finland Oy',
                'Bewi Styrochem Oy',
                'Chemigate Oy',
                'CH-Polymers Oy',
                'Chromaflo Technologies',
                'ContiTech Finland Oy',
                'Dynea Chemicals Oy',
                'Ekokem Oyj',
                'Epsira Oy',
                'Eurocon Oy',
                'Eurofins Viljavuuspalvelu Oy',
                'Finex Oy',
                'Fiskars Home Oy Ab',
                'Forchem Oy',
                'Hexion Oy',
                'Huhtamäki Foodservice Finland Oy',
                'J.M. Huber Finland Oy',
                'Kiilto Oy',
                'Kumiapu Oy',
                'Lumon Oy',
                'Marwe Oy',
                'Nammo Vihtavuori Oy',
                'Nor-Maali Oy',
                'Orion Oyj',
                'PCAS Finland Oy',
                'PQ Finland Oy',
                'Roal Oy',
                'Saint-Gobain Rakennustuotteet Oy',
                'Santen Oy',
                'Solenis Finland Oy',
                'Sun Chemical Oy',
                'Synthomer Finland Oy',
                'Teknikum-yhtiöt Oy',
                'Teknos Oy',
                'Tikkurila Oyj'
              ]
            },
            {
              smalltitle: 'Muoviteollisuuden toimenpideohjelma',
            },
            {
              list: [
                'A-Kassi Oy',
                'Amcor Flexibles Finland Oy',
                'Amerplast Oy',
                'Artekno Oy',
                'Biaxis Oy Ltd',
                'Coveris Rigid Finland Oy',
                'Europak Oy',
                'Finnfoam Oy',
                'Hella Lighting Finland Oy',
                'Herrmans Oyj Ab',
                'Jokamuovi Oy',
                'Logstor Finland Oy',
                'Medisize Oy',
                'MK-Tresmer Oy',
                'Muovijaloste Oy',
                'Okartek Oy',
                'Orthex Oy Ab',
                'Oy Rani Tervakoski Ab',
                'Parlok Oy Ab',
                'Pipelife Finland Oy',
                'Plastep Oy',
                'Plastex Oy Ab',
                'Plastiroll Oy',
                'Premix Oy',
                'Primo Finland Oy Ab',
                'Promens Oy',
                'RKW Finland Oy',
                'Serres Oy',
                'SPU Systems Oy',
                'SX-Lämpöpohja Oy',
                'ThermiSol Oy',
                'Thermo Fisher Scientific Oy, Joensuun tehdas',
                'Toijalan Kotelotehdas Oy',
                'Treston Oy',
                'Uponor Infra Oy',
                'Wipak Oy'
              ]
            },
            {
              smalltitle: 'Puutuoteteollisuuden toimenpideohjelma',
            },
            {
              list: [
                'Domus Yhtiöt Oy',
                'FM-Haus Oy',
                'Formica IKI Oy',
                'Haapajärven Ha-Sa Oy, Haapaveden Ha-Sa Oy',
                'Iin Fasadi Oy',
                'Kankarin Kaluste Oy',
                'Metsäliitto Osuuskunta',
                'Misawa Homes of Finland',
                'Olavi Räsänen Oy',
                'Palokan Puutuote Oy',
                'Pölkky Oy',
                'SCA Hygiene Products Oy Ab',
                'Skaala Oy',
                'Sonoco Alcore Oy',
                'Stora Enso Oyj',
                'Suomen Kuitulevy Oy',
                'Walki Oy',
                'Vapo Timber Oy',
                'Versowood Oy',
                'Westas Group Oy'
              ]
            },
            {
              smalltitle: 'Teknologiateollisuuden toimenpideohjelma',
            },
            {
              list: [
                'ABB Oy',
                'Abloy Oy',
                'Agco Power Oy',
                'Agnico-Eagle Finland Oy',
                'Airam Electric Oy Ab',
                'AkerArcticTechnology Oy',
                'Allaway Oy',
                'Arctech Helsinki Shipyard Oy',
                'Aslemetals Oy',
                'Aurajoki Oy',
                'Aurubis Finland Oy',
                'Carrus Delta Oy',
                'Componenta Oyj',
                'Dino Lift Oy',
                'Draka NK Cabels Oy',
                'Ensto Oy',
                'FennoSteel Oy',
                'Finnegrip Oy',
                'Finn-Power Oy',
                'Fiskars Brands Finland Oy Ab',
                'Fläkt Woods Oy',
                'FNsteel Dalwire Oy Ab',
                'Franke Finland Oy',
                'GE Healthcare Finland Oy',
                'Halton Oy',
                'Hannumet Oy',
                'Helvar Oy Ab',
                'HTM Yhtiöt Oy',
                'Hydoring Oy',
                'Javasko Oy',
                'John Deere Forestry Oy',
                'Kankaanpää Works Oy',
                'Kaso Oy',
                'Katsa Oy',
                'Kemppi Oy',
                'Kone Oyj',
                'Konecranes Oy',
                'Kumera  Drives Oy',
                'Kuusakoski Oy',
                'Kymppi Eristys Oy',
                'Kyrel Oy',
                'Laitila Coating Oy (Kiinteistöyhtiö Oy Laitilan Halimaa)',
                'Lapuan Piristeel Oy',
                'Laserkeskus Oy',
                'Lehtosen Konepaja Oy',
                'Leinovalu Oy',
                'Levypyörä Oy',
                'Loval Oy',
                'Lännen Tractors Oy',
                'M.Haloila Oy Ab',
                'Marioff Corporation Oy',
                'Meka Pro Oy',
                'Mepu Oy',
                'Metos Oy Ab',
                'Metso Oyj',
                'Moventas Gears Oy',
                'Nammo Lapua Oy',
                'NARVI Oy',
                'Naval Oy',
                'Neorem Magnets Oy',
                'Nesco Oy',
                'Nokia Solutions and Networks Asset Management Oy',
                'Nokka-Yhtiöt Oy',
                'Nordhydraulic Oy Ab',
                'Norpe Oy',
                'Ojala Yhtymä Oy',
                'Oras Oy',
                'Orima-Tuote Oy',
                'Outotec Oyj',
                'Oy Kart Ab',
                'Pajakulma Oy',
                'Paramet Konepaja Oy',
                'Patria Aerostructures Oy',
                'Patria Aviation Oy',
                'Patria Land Services Oy',
                'Pikval Oy',
                'Pilkington Automotive Finland Oy',
                'Polar Electro Oy',
                'Ponsse Oyj',
                'Premec Oy',
                'Prolaser Oy',
                'Prysmian Cables and Systems Oy',
                'Purso Oy',
                'Pyhäsalmi Mine Oy',
                'Rautaruukki Oyj',
                'Raute Oyj',
                'Reka Kaapeli Oy',
                'REMU Oy',
                'Rettig Värme Ab',
                'Sacotec Components Oy',
                'Sahala Works',
                'SAH-KO Oy',
                'Sako Oy',
                'Salon Metalelektro Oy',
                'Sampo Hydraulics Oy',
                'Sampo-Rosenlew Oy',
                'Sandvik Mining and Construction Oy',
                'Sanmina-SCI EMS Haukipudas Oy',
                'Savonlinna Works Oy',
                'Scan-Cast Oy',
                'Scanfil EMS Oy',
                'SEW Industrial Gears Oy',
                'SKF Oy Ab, Muurame',
                'Solar Kaihdin Ky',
                'Stera Technologies Oy',
                'Steris Europe, Inc. Suomen sivuliike',
                'Sulzer Pumps Finland Oy',
                'Svanmet Oy',
                'Tarvasjoen Teräsovi Oy',
                'TEVO Oy',
                'TKM TTT Finland Oy',
                'Trafotek Oy',
                'Uudenkaupungin Rautavalimo Oy',
                'Vaahto Group Plc Oyj',
                'Vacon Oy',
                'Vaisala Oyj',
                'Valmet Automotive Oy',
                'Valmet Oyj',
                'Valonkone Oy',
                'Valtra Oy',
                'Wavin- Labko Oy',
                'Wipro Infrastructure Engineering Oy',
                'Wärtsilä Oyj',
                'YIT Oyj'
              ]
            },
            {
              smalltitle: 'Yleinen – teollisuus toimenpideohjelma',
            },
            {
              list: [
                'Betoniluoma Oy',
                'Betoni-Sampo Oy',
                'Cembrit Oy',
                'Finnair Facilities Management Oy',
                'Freudenberg Household Products Oy Ab',
                'Helprint Oy',
                'Icopal Oy',
                'Karjalan tekstiilipalvelu Oy',
                'Katepal Oy',
                'Lujabetoni Oy',
                'Länsi-Savo Oy',
                'Mittatehdas Oy',
                'Otavan Kirjapaino Oy',
                'PMK Värjäämö Oy',
                'PunaMusta Oy',
                'Päijät-Hämeen Tekstiilihuolto Oy',
                'Rakennusbetoni- ja Elementti Oy',
                'Recticel Oy',
                'Rudus Oy',
                'Sanoma Oyj',
                'SharpCell Oy',
                'Suur-Savon Sähkötyö Oy',
                'TS-Yhtymä Oy',
                'Tulikivi Oy',
                'Uusioaines Oy'
              ]
            },
            {
              smalltitle: 'Energiantuotannon toimenpideohjelma',
            },
            {
              list: [
                'Adven Oy',
                'Alholmens kraft Oy Ab',
                'Elenia Lämpö Oy',
                'Etelä-Savon Energia Oy',
                'Fortum Power and Heat Oy',
                'Helen Oy',
                'Jyväskylän Energia Oy',
                'Kanteleen Voima Oy',
                'Kemijoki Oy',
                'Keravan Energia Oy',
                'Kotkan Energia Oy',
                'KSS Energia Oy',
                'Kuopion Energia Oy',
                'Kurikan Kaukolämpö Oy',
                'Kymin Voima Oy',
                'Laanilan Voima Oy',
                'Lahti Energia Oy',
                'Lappeenrannan Lämpövoima Oy',
                'Leppäkosken Energia Oy',
                'Napapiirin Energia ja Vesi Oy',
                'Nokianvirran Energia Oy',
                'Oriveden Aluelämpö Oy',
                'Oulun Energia Oy',
                'Pohjois-Karjalan Sähkö Oy',
                'Pori Energia Oy',
                'Porin Prosessivoima Oy',
                'Porvoon Energia Oy - Borgå Energi Ab',
                'PVO-Lämpövoima Oy',
                'PVO-Vesivoima Oy',
                'Savon Voima Oyj',
                'Suur Savon Sähkö Oy',
                'Tampereen sähkölaitos',
                'Teollisuuden Voima Oyj',
                'Tornion Voima Oy',
                'Vantaan Energia Oy',
                'Vapo Oy',
                'Vaskiluodon Voima Oy',
                'Vattenfall Oy, Vesivoima',
                'Vieskan Voima Oy'
              ]
            },
            {
              smalltitle: 'Energiapalveluiden toimenpideohjelma'
            },
            {
              list: [
                'Adven Oy',
                'Alajärven Lämpö Oy',
                'Caruna Espoo Distribution Oy',
                'Caruna Oy',
                'Ekenäs Energi Ab / Tammisaaren Energia Oy',
                'Elenia Lämpö Oy',
                'Elenia Oy',
                'Energiapolar Oy',
                'EPV Alueverkko Oy',
                'ESE-Verkko Oy',
                'Etelä-Savon Energia Oy',
                'Etelä-Suomen Energia Oy',
                'Fingrid Oyj',
                'Forssan Energia Oy',
                'Forssan Verkkopalvelut Oy',
                'Fortum Markets Oy',
                'Fortum Power and Heat Oy (Heat)',
                'Haminan Energia Oy',
                'Helen Oy',
                'Helen Sähköverkko Oy',
                'Hyvinkään lämpövoima Oy',
                'Imatran Seudun Sähkö Oy',
                'Imatran Seudun Sähkönsiirto Oy',
                'Inergia Oy',
                'JE-Siirto Oy',
                'Jyväskylän Energia Oy',
                'Jämsän Aluelämpö Oy',
                'Järvi-Suomen Energia Oy',
                'Karhu Voima Oy',
                'Kemin Energia Oy',
                'Keravan Energia Oy',
                'Keskusosuuskunta Oulun Seudun Sähkö',
                'Koillis-Satakunnan Sähkö Oy',
                'Kokemäen Sähkö Oy',
                'Kotkan Energia Oy',
                'KSS Energia Oy',
                'KSS Verkko Oy',
                'Kuopion Energia',
                'Kuopion Energia Oy',
                'Kymenlaakson Sähkö Oy',
                'Kymenlaakson Sähköverkko Oy',
                'Köyliön- Säkylän Sähkö Oy',
                'Lahti Energia Oy',
                'Laihian Nuuka Lämpö Oy',
                'Lappeenrannan Energia Oy',
                'Lempäälän Lämpö Oy',
                'Leppäkosken Energia Oy',
                'Leppäkosken Sähkö Oy',
                'LE-Sähköverkko Oy',
                'Loiste Energia Oy',
                'Loiste Lämpö Oy (ent. Kajaanin Lämpö Oy)',
                'Loiste Sähköverkko Oy',
                'Mäntsälän Sähkö Oy',
                'Napapiirin Energia ja Vesi Oy',
                'Nurmijärven Sähkö Oy',
                'Nurmijärven Sähköverkko Oy',
                'Otanmäen Lämpö Oy',
                'Oulun Energia Oy',
                'Oulun Energia Siirto ja Jakelu Oy',
                'Oulun sähkönmyynti Oy',
                'Paneliankosken Voima Oy',
                'Parikkalan Valo Oy',
                'PKS Sähkönsiirto Oy',
                'Pohjois-Karjalan Sähkö Oy',
                'Pori Energia Oy',
                'Pori Energia Sähköverkot Oy',
                'Porvoon Energia Oy - Borgå Energi Ab',
                'Porvoon Sähköverkko Oy',
                'Raahen Energia Oy',
                'Rauman Energia Oy',
                'Riihimäen Kaukolämpö Oy',
                'Rovakaira Oy',
                'Rovaniemen Verkko Oy',
                'Sallila Energia Oy',
                'Sallila Sähkönsiirto Oy',
                'Sastamalan Lämpö Oy',
                'Savon Voima Oyj',
                'Savon Voima Verkko Oy',
                'Suur Savon Sähkö Oy',
                'Switch Nordic Green AB Filial Finland',
                'Tampereen sähkölaitos',
                'Tampereen Sähköverkko Oy',
                'Tornion Energia Oy',
                'Tornionlaakson Sähkö Oy',
                'Turku Energia Oy - Åbo Energi Ab',
                'Turku Energia Sähköverkot Oy',
                'Vaasan Sähkö Oy',
                'Vaasan Sähkö Oy, kaukolämpöyksikkö',
                'Vaasan Sähköverkko Oy',
                'Vantaan Energia Oy',
                'Vantaan Energia Sähköverkot Oy',
                'Varkauden Aluelämpö Oy',
                'Vatajankosken Sähkö Oy',
                'Vattenfall Oy'
              ]
            },
            {
              smalltitle: 'Autoalan toimenpideohjelma',
            },
            {
              list: [
                'Aro Yhtymä',
                'Auto-Kilta Oy',
                'Hämeen Autovaruste',
                'Kiinteistö Oy Lohikoskenkulma',
                'Kiinteistö Oy Lokomonkulma',
                'Kittilän Autopeltikorjaamo ja Maalaamo Oy',
                'Käyttöauto Oy',
                'O.K Auto Oy',
                'Pörhön Autoliike Oy',
                'Scania Suomi Oy',
                'Timosen Auto Oy',
                'Veho Group Oy Ab',
                'VV-Autotalo Oy ja Turun VV-Auto Oy'
              ]
            },
            {
              smalltitle: 'Kaupan alan toimenpideohjelma\n',
            },
            {
              list: [
                'Carlson Oy',
                'Hong Kong Import Oy Ltd',
                'Isojoen Konehalli Oy',
                'Jysk Oy',
                'Kesko Oyj',
                'Keuruun Megamarket Oy',
                'KWH Freeze Oy Ab',
                'Kärkkäinen Express Oy',
                'Lähdesmäki Oy Ilmajoki',
                'Motonet Oy',
                'Starkki Oy',
                'Stockmann Oy Ab/ Suomen tavaratalot',
                'Suomen Lähikauppa Oy',
                'Suomen Osuuskauppojen Keskuskunta',
                'Suomen Palvelutukkurit Oy',
                'Taloustalo Oy',
                'Tokmanni Oy',
                'TukkuHeino Oy',
                'Tuko Logistics Osuuskunta',
                'Variflex Oy',
                'Veljekset Keskinen Oy'
              ]
            },
            {
              smalltitle: 'Matkailu- ja Ravintolapalvelut MaRa ry:n toimenpideohjelma',
            },
            {
              list: [
                'Citymac Travels Oy',
                'Deltarec Oy / Hiihtokeskus Sappee',
                'Gustavelund Oy',
                'Harriniva Oy',
                'Herrankukkaro Oy',
                'Hiihtokeskus Himosvuori Oy',
                'Hiihtokeskus Iso-Ylläs Oy',
                'Hotel Santa Claus Oy',
                'Hotelli Käenpesä',
                'Hotelli Luostotunturi Oy',
                'Hotelli Mesikämmen Oy',
                'Hotelli Rantakalla Oy',
                'Hotelliyhtymä Oy / Hotelli Helka',
                'Hullu Poro Oy',
                'Häkärinteet Oy',
                'Imatran kylpylä /Etelä-Karjalan Kuntoutumissäätiö',
                'Jepetron Oy',
                'Järjestötalo Oy / MaRa ry.',
                'Ka-Bir Oy',
                'Karjalohjan Päiväkumpu Oy',
                'Kiinteistö Oy Koutalaki 1',
                'Kuntoranta Oy',
                'Kuopion Kylpylä Oy',
                'Kymen Paviljonki Oy',
                'Kämp Group Oy',
                'Kätkä Viisi Oy',
                'Lasten Päivän Säätiö',
                'Levi Ski Resort Oy Ltd',
                'Levin Luontokeskus Oy',
                'Mattilanniemen Hotelli Oy',
                'Nemeko Oy/Scandic Oscar',
                'Park Marketing Oy / Park Hotel Turku',
                'Peurunka-konserni',
                'Pyhätunturi Oy',
                'Ravolta hotellit ja ravintolat Oy/ Next Hotel Rivoli Jardin',
                'Restel Oy',
                'Rukakeskus Oy',
                'Ryokan Oy',
                'Saarijärven Kylpylä Oy',
                'Saariselän tunturihotellit Oy',
                'Saija Oy',
                'Scandic Hotels Oy',
                'Scanredi Oy Ab',
                'StayAt Finland Oy',
                'ST-Ravintolat Oy',
                'Suomen Latu ry/ Suomen Latu Kiilopää',
                'Suomen Osuuskauppojen Keskuskunta',
                'Talma Ski Oy',
                'Tampereen Särkänniemi Oy',
                'Tykkimäen Vapaa-aikakeskus Oy',
                'Vuoristo-yhtiöt Oy',
                'Yyterin Kylpylähotelli Oy'
              ]
            },
            {
              smalltitle: 'Yleinen – palveluala',
            },
            {
              list: [
                'AEL Oy',
                'Betesda-säätiö',
                'Blue Lake Communications Oy',
                'DHL Supply Chain (Finland) Oy',
                'Eerikkilän Jalkapallohalli Oy',
                'Espoon Tennistuki ry',
                'Esport Arena Oy',
                'Europark Finland Oy',
                'Fastighets Ab Ekenäs Kungsgatan 7',
                'Fitness & Aerobic Club Oy',
                'Granlund Oy',
                'HAVI Logistics Oy',
                'Hämeenkyrön Jäähalli Oy',
                'Julius Tallberg-Kiinteistöt Oyj',
                'Jyväskylän Talouskouluyhdistys ry',
                'Karis Telefon Ab',
                'Kauppakeskus Itäkeskus Oy',
                'Kiinteistö Oy Honkahalli',
                'Kiinteistö Oy Kerttulan Jäähalli',
                'Kiinteistö Oy Tampereen Myllypuronkatu 30',
                'Kiinteistökomppania Oy',
                'Kiipulasäätiö',
                'Kuehne + Nagel Oy Ltd',
                'Kuusankosken Palloiluhalli Oy',
                'Lahden Jäähalli Oy',
                'Lauttasaaren Pienteollisuustalo Oy',
                'Limingan jäähalli Oy',
                'Loimijokilaakson Jäähalli Oy',
                'Mercator Oy Ab',
                'Myllypuron Tenniskeskus Oy',
                'Oulun Palloiluhallit Oy',
                'Oulun Sisustajat Oy',
                'Oy Julius Tallberg Ab',
                'Sipoon Jäähalli Oy - Sibbo Ishall Ab',
                'Suomen Messut Osuuskunta',
                'Tampereen Aikuiskoulutussäätiö / Aikuiskoulutuskeskus',
                'Tampereen ammattikorkeakoulu',
                'Tapiolan Monitoimiareena Oy',
                'Tuusulan Jäähalli Oy',
                'Työtehoseura ry',
                'Urjalan Jäähalli Oy',
                'Valtakunnallinen valmennus- ja liikuntakeskus Oy',
                'Veikkaus Oy'
              ]
            },


            {
              smalltitle: 'Vuokra-asuntoyhteisöjen toimenpideohjelma',
            },
            {
              list: [
                'A-Kruunu Oy',
                'Asuntosäätiö',
                'Domus Arctica -säätiö',
                'Espoon Asunnot Oy',
                'Helsingin kaupungin asuinkiinteistöyhtiöt',
                'Helsingin seudun opiskelija-asuntosäätiö HOAS',
                'Jyväskylän Vuokra-asunnot Oy',
                'Jyväskylän yliopiston ylioppilaskunta',
                'Järvenpään Mestariasunnot Oy',
                'Keskinäinen eläkevakuutusyhtiö Ilmarinen',
                'Kiinteistö Oy Nikkarinkruunu',
                'Kiinteistö Oy Pikipruukki Fastighets Ab',
                'Kruunuasunnot Oy',
                'Lahden Talot Oy',
                'LähiTapiola Kiinteistövarainhoito Oy',
                'Mikalo Oy',
                'Niiralan Kulma Oy',
                'Sato Oyj',
                'Sivakka-yhtymä Oy',
                'Suomen Asumisoikeus Oy (Asokodit)',
                'Tampereen vuokratalosäätiö',
                'TVT Asunnot Oy',
                'Vaasan opiskelija-asuntosäätiö (VOAS)',
                'Varsinais-Suomen Asumisoikeus Oy',
                'VAV Asunnot Oy',
                'Vilusen Rinne Oy',
                'VVO-yhtymä Oyj'
              ]
            },
            {
              smalltitle: 'Toimitilayhteisöjen toimenpideohjelma',
            },
            {
              list: [
                'Aalto Yliopistokiinteistöt Oy',
                'Aberdeen European Balanced Property Fund',
                'Aberdeen Property Fund Finland I Ky (APFF)',
                'Aberdeen Property Funds Sicav-Fis Pan Nordic',
                'Aberdeen Property Nordic Fund I Sicav',
                'Antilooppi Ky',
                'Citycon Oyj',
                'Cursor Oy',
                'Espoon Martinportti Oy',
                'Exilion Real Estate 1 Ky',
                'Genesta Property Nordic Finland Oy',
                'Helsingin Autotalo Oy',
                'Helsingin yliopiston ylioppilaskunta HYY',
                'Isku Invest Oy',
                'Jyväskylän Kassatalo Oy',
                'Kauppakeskus H-talo = Kiint. Oy Kuopion Haapaniemenkatu 20',
                'Kauppakeskuskiinteistöt FEA Ky',
                'Kerta Kiinteistöt Oy',
                'Keskinäinen Eläkevakuutusyhtiö Etera',
                'Keskinäinen eläkevakuutusyhtiö Ilmarinen',
                'Keskinäinen työeläkevakuutusyhtiö Varma',
                'Keva',
                'KI Oy Vantaan Rajatorpantie 8',
                'Kiinteistö Oy Kaarinantori',
                'Kiinteistö Oy Kangasalan Pikonlinna',
                'Kiinteistö Oy Koivulan Liikekeskus',
                'Kiinteistö Oy Kurssipesä',
                'Koy Alakortes',
                'Koy Kauppakeskus Sello',
                'Koy Malmin Asematie 6',
                'Logicor Oy',
                'Lyy-Invest Oy',
                'LähiTapiola Kiinteistövarainhoito Oy',
                'Niam Oy (Niam V HOP Holding Ab ja Niam V Two Star Holding Ab (Niam V)',
                'Nordea Henkivakuutus Suomi Oy',
                'Peimarin Koulutuskuntayhtymä',
                'Puolustushallinnon rakennuslaitos',
                'Raision Seurakunta',
                'Sagax Finland Oy',
                'Sampo Oyj',
                'Senaatti-kiinteistöt',
                'Sponda (Sponda Oyj ja Sponda Kiinteistöt Oy)',
                'Suomen Yliopistokiinteistöt Oy',
                'Technopolis Oyj',
                'Teollisuuskeskus Oy',
                'Valad Finland Oy',
                'Varisto Invest Oy',
                'Vioto Oy',
                'Vuokrakartio Oy'
              ]
            },
            {
              title: 'Kunta-alan energiatehokkuussopimus 2008-2016 liittyneet'
            },
            {
              smalltitle: 'Kuntien energiatehokkuussopimus 2008-2016',
            },
            {
              list: [
                'Akaa',
                'Espoo',
                'Eura',
                'Hamina',
                'Hankasalmi',
                'Heinola',
                'Helsinki',
                'Hyvinkää',
                'Ii',
                'Imatra',
                'Janakkala',
                'Joensuu',
                'Jyväskylä',
                'Järvenpää',
                'Kajaani',
                'Kangasala',
                'Kauniainen',
                'Kemi',
                'Kerava',
                'Kirkkonummi',
                'Kiuruvesi',
                'Kokkola',
                'Kotka',
                'Kouvola',
                'Kristiinankaupunki',
                'Kuopio',
                'Lahti',
                'Lappeenranta',
                'Laukaa',
                'Lempäälä',
                'Lieto',
                'Lieksa',
                'Lohja',
                'Mikkeli',
                'Mynämäki',
                'Mäntsälä',
                'Nokia',
                'Oulu',
                'Pieksämäki',
                'Pori',
                'Porvoo',
                'Raasepori',
                'Raisio',
                'Rauma',
                'Riihimäki',
                'Rovaniemi',
                'Saarijärvi',
                'Salo',
                'Sastamala',
                'Savonlinna',
                'Seinäjoki',
                'Siilinjärvi',
                'Siuntio',
                'Sodankylä',
                'Tampere',
                'Turku',
                'Tuusula',
                'Uusikaupunki',
                'Vaasa',
                'Valkeakoski',
                'Vantaa',
                'Varkaus',
                'Ylöjärvi',
                'Äänekoski',
                'Helsingin seudun ympäristöpalvelut kuntayhtymä',
                'HUS-kuntayhtymä',
                'Jyväskylän koulutuskuntayhtymä',
                'Kemi-Tornionlaakson koulutuskuntayhtymä',
                'Keski-Uudenmaan koulutuskuntayhtymä',
                'Kymenlaakson sairaanhoito- ja sosiaalipalvelujen kuntayhtymä, Carea',
                'Oulun seudun koulutuskuntayhtymä',
                'Pirkanmaan sairaanhoitopiirin kuntayhtymä',
                'Pohjois-Pohjanmaan sairaanhoitopiirin kuntayhtymä',
                'Pohjois-Savon Sairaanhoitopiirin kuntayhtymä',
                'Päijät-Hämeen koulutuskonserni -kuntayhtymä',
                'Rovaniemen koulutus-kuntayhtymä',
                'Vaasan sairaanhoitopiirin kuntayhtymä'
              ]
            },
            {
              smalltitle: 'Kuntien energiaohjelma 2008-2016',
            },
            {
              list: [
                'Alavuus',
                'Asikkala',
                'Haukipudas',
                'Iitti',
                'Ilmajoki',
                'Ilomantsi',
                'Inari',
                'Inkoo',
                'Isojoki',
                'Jalasjärvi',
                'Jokioinen',
                'Jämsä',
                'Kalajoki',
                'Karkkila',
                'Kauhajoki',
                'Kemijärvi',
                'Kerimäki',
                'Kuhmoinen',
                'Kuortane',
                'Kurikka',
                'Kuusamo',
                'Laihia',
                'Laitila',
                'Lapua',
                'Leppävirta',
                'Lestijärvi',
                'Liminka',
                'Loviisa',
                'Muhos',
                'Nurmes',
                'Närpiö',
                'Orimattila',
                'Orivesi',
                'Padasjoki',
                'Parikkala',
                'Pelkosenniemi',
                'Pietarsaari',
                'Pirkkala',
                'Pudasjärvi',
                'Pyhäranta',
                'Ranua',
                'Rautjärvi',
                'Ristiina',
                'Sievi',
                'Simo',
                'Sipoo',
                'Taivalkoski',
                'Teuvan kunta',
                'Toholampi',
                'Toivakka',
                'Urjala',
                'Uurainen',
                'Valtimo',
                'Veteli',
                'Virrat',
                'Mikkelin Ammattikorkeakoulu Oy',
                'Ylä-Savon SOTE kuntayhtymä'
              ]
            },
            {
              smalltitle: 'Lämmitys- ja liikennepolttonesteiden jakelutoiminnan energiatehokkuussopimus HÖYLÄ III 2008-2016',
            },
            {
              list: [
                'Neste Markkinointi Oy',
                'Oy Shell Ab',
                'St1 Oy',
                'Suomalainen Energiaosuuskunta (SEO)',
                'Suomen Osuuskauppojen Keskuskunta',
                'Oy Teboil Ab'
              ]
            }
          ];
        this.pageTitleEN = 'Participants';
        this.pageContentsEN =
          [
            {
              title: 'Energy efficiency agreement for industries 2008-2016'
            },
            {
              smalltitle: 'Action plan for the Energy-Intensive Industry',
            },
            {
              list: [
                'AGA Oy Ab',
                'Akzo Nobel Finland Oy',
                'Boliden Harjavalta Oy',
                'Boliden Kokkola Oy',
                'Borealis Polymers Oy',
                'Corenso United Oy Ltd',
                'CP Kelco Oy',
                'Finnfeeds Finland Oy',
                'Finnsementti Oy',
                'Freeport Cobalt Oy',
                'Gasum Oy',
                'Genencor International Oy',
                'Huntsman Pigments and Additives',
                'Kemira Oyj',
                'Koskisen Oy',
                'Kotkamills Oy',
                'Luvata Pori Oy',
                'Metsä Board Oyj',
                'Metsä Fibre Oy (ent. Metsä Botnia)',
                'Metsä Tissue Corp.',
                'Mondo Minerals BV Branch Finland',
                'Neste Oyj',
                'Nokian Renkaat Oyj',
                'Nordkalk Oy Ab',
                'Norilsk Nickel Harjavalta Oy',
                'Outokumpu Oyj',
                'Ovako Bar Oy Ab',
                'Pankaboard Oy',
                'Paroc Oy Ab',
                'Raisio konserni',
                'Rautaruukki Oyj',
                'Sappi Finland I Oy',
                'Savon Sellu Oy',
                'Solvay Chemicals Finland Oy',
                'Stora Enso Oyj',
                'Sucros konserni',
                'Suominen Kuitukankaat Oy',
                'Taminco Finland Oy',
                'Tervakoski Oy',
                'UPM-Kymmene Oyj',
                'Yara Suomi Oy'
              ]
            },
            {
              smalltitle: 'Action plan for the Food and Drink Industries',
            },
            {
              list: [
                'Altia Oyj',
                'Apetit Oyj',
                'Arla Oy',
                'Atria Suomi Oyj',
                'Eckes-Granini Finland Oy Ab',
                'Fazer Leipomot Oy',
                'Fazer Makeiset Oy',
                'Findest Protein Oy',
                'Gustav Paulig Oy Ab',
                'Halva Oy Ab',
                'Hartwall Oy Ab',
                'HKScan Finland Oy',
                'Honkajoki Oy',
                'Hämeenlinnan Osuusmeijeri',
                'Juustoportti Food Oy',
                'Kotivara Oy',
                'Kymppi-Maukkaat Oy',
                'Laihian Mallas Oy',
                'Laitilan Wirvoitusjuomatehdas',
                'Lankoski Oy',
                'Lantmännen Unibake Ab Finland Oy',
                'Leipomo ja konditoria Nurmi & Sulonen Oy',
                'Liisan Leipomo Oy',
                'Linkosuon Leipomo Oy',
                'Lunden Oy Ab Jalostaja',
                'MP-Maustepalvelu Oy',
                'Mush Oy Ltd',
                'Olvi Oyj',
                'Osuuskunta Satamaito',
                'Oy Emilsberg Ab',
                'Paisto-Mestari Oy',
                'Panda Oy Ab',
                'Pernod Ricard Finland Oy',
                'Pirjon Pakari Ky',
                'Pohjolan Peruna Oy',
                'Polarica Oy',
                'Polttimo Oy',
                'Saarioinen Oy',
                'Sinebrychoff Oy Ab',
                'Snellmannin Kokkikartano Oy',
                'Snellmans Köttförädling Ab',
                'Toripiha Oy',
                'Valio Oy',
                'Veljekset Mattila Oy',
                'Veraisen Leipomo Oy',
                'Wursti Oy J & J',
                'Yrjö Wigren Oy'
              ]
            },
            {
              smalltitle: 'Action plan for the Chemical Industries'
            },
            {
              list: [
                'Akkuser Oy',
                'Arizona Chemical Oy',
                'Arwina Oy',
                'Ashland Finland Oy',
                'Bewi Styrochem Oy',
                'Chemigate Oy',
                'CH-Polymers Oy',
                'Chromaflo Technologies',
                'ContiTech Finland Oy',
                'Dynea Chemicals Oy',
                'Ekokem Oyj',
                'Epsira Oy',
                'Eurocon Oy',
                'Eurofins Viljavuuspalvelu Oy',
                'Finex Oy',
                'Fiskars Home Oy Ab',
                'Forchem Oy',
                'Hexion Oy',
                'Huhtamäki Foodservice Finland Oy',
                'J.M. Huber Finland Oy',
                'Kiilto Oy',
                'Kumiapu Oy',
                'Lumon Oy',
                'Marwe Oy',
                'Nammo Vihtavuori Oy',
                'Nor-Maali Oy',
                'Orion Oyj',
                'PCAS Finland Oy',
                'PQ Finland Oy',
                'Roal Oy',
                'Saint-Gobain Rakennustuotteet Oy',
                'Santen Oy',
                'Solenis Finland Oy',
                'Sun Chemical Oy',
                'Synthomer Finland Oy',
                'Teknikum-yhtiöt Oy',
                'Teknos Oy',
                'Tikkurila Oyj'
              ]
            },
            {
              smalltitle: 'Action plan for the Plastic Industries',
            },
            {
              list: [
                'A-Kassi Oy',
                'Amcor Flexibles Finland Oy',
                'Amerplast Oy',
                'Artekno Oy',
                'Biaxis Oy Ltd',
                'Coveris Rigid Finland Oy',
                'Europak Oy',
                'Finnfoam Oy',
                'Hella Lighting Finland Oy',
                'Herrmans Oyj Ab',
                'Jokamuovi Oy',
                'Logstor Finland Oy',
                'Medisize Oy',
                'MK-Tresmer Oy',
                'Muovijaloste Oy',
                'Okartek Oy',
                'Orthex Oy Ab',
                'Oy Rani Tervakoski Ab',
                'Parlok Oy Ab',
                'Pipelife Finland Oy',
                'Plastep Oy',
                'Plastex Oy Ab',
                'Plastiroll Oy',
                'Premix Oy',
                'Primo Finland Oy Ab',
                'Promens Oy',
                'RKW Finland Oy',
                'Serres Oy',
                'SPU Systems Oy',
                'SX-Lämpöpohja Oy',
                'ThermiSol Oy',
                'Thermo Fisher Scientific Oy, Joensuun tehdas',
                'Toijalan Kotelotehdas Oy',
                'Treston Oy',
                'Uponor Infra Oy',
                'Wipak Oy'
              ]
            },
            {
              smalltitle: 'Action plan for the Wood Product Industries',
            },
            {
              list: [
                'Domus Yhtiöt Oy',
                'FM-Haus Oy',
                'Formica IKI Oy',
                'Haapajärven Ha-Sa Oy, Haapaveden Ha-Sa Oy',
                'Iin Fasadi Oy',
                'Kankarin Kaluste Oy',
                'Metsäliitto Osuuskunta',
                'Misawa Homes of Finland',
                'Olavi Räsänen Oy',
                'Palokan Puutuote Oy',
                'Pölkky Oy',
                'SCA Hygiene Products Oy Ab',
                'Skaala Oy',
                'Sonoco Alcore Oy',
                'Stora Enso Oyj',
                'Suomen Kuitulevy Oy',
                'Walki Oy',
                'Vapo Timber Oy',
                'Versowood Oy',
                'Westas Group Oy'
              ]
            },
            {
              smalltitle: 'Action Plan for the Technology Industries',
            },
            {
              list: [
                'ABB Oy',
                'Abloy Oy',
                'Agco Power Oy',
                'Agnico-Eagle Finland Oy',
                'Airam Electric Oy Ab',
                'AkerArcticTechnology Oy',
                'Allaway Oy',
                'Arctech Helsinki Shipyard Oy',
                'Aslemetals Oy',
                'Aurajoki Oy',
                'Aurubis Finland Oy',
                'Carrus Delta Oy',
                'Componenta Oyj',
                'Dino Lift Oy',
                'Draka NK Cabels Oy',
                'Ensto Oy',
                'FennoSteel Oy',
                'Finnegrip Oy',
                'Finn-Power Oy',
                'Fiskars Brands Finland Oy Ab',
                'Fläkt Woods Oy',
                'FNsteel Dalwire Oy Ab',
                'Franke Finland Oy',
                'GE Healthcare Finland Oy',
                'Halton Oy',
                'Hannumet Oy',
                'Helvar Oy Ab',
                'HTM Yhtiöt Oy',
                'Hydoring Oy',
                'Javasko Oy',
                'John Deere Forestry Oy',
                'Kankaanpää Works Oy',
                'Kaso Oy',
                'Katsa Oy',
                'Kemppi Oy',
                'Kone Oyj',
                'Konecranes Oy',
                'Kumera  Drives Oy',
                'Kuusakoski Oy',
                'Kymppi Eristys Oy',
                'Kyrel Oy',
                'Laitila Coating Oy (Kiinteistöyhtiö Oy Laitilan Halimaa)',
                'Lapuan Piristeel Oy',
                'Laserkeskus Oy',
                'Lehtosen Konepaja Oy',
                'Leinovalu Oy',
                'Levypyörä Oy',
                'Loval Oy',
                'Lännen Tractors Oy',
                'M.Haloila Oy Ab',
                'Marioff Corporation Oy',
                'Meka Pro Oy',
                'Mepu Oy',
                'Metos Oy Ab',
                'Metso Oyj',
                'Moventas Gears Oy',
                'Nammo Lapua Oy',
                'NARVI Oy',
                'Naval Oy',
                'Neorem Magnets Oy',
                'Nesco Oy',
                'Nokia Solutions and Networks Asset Management Oy',
                'Nokka-Yhtiöt Oy',
                'Nordhydraulic Oy Ab',
                'Norpe Oy',
                'Ojala Yhtymä Oy',
                'Oras Oy',
                'Orima-Tuote Oy',
                'Outotec Oyj',
                'Oy Kart Ab',
                'Pajakulma Oy',
                'Paramet Konepaja Oy',
                'Patria Aerostructures Oy',
                'Patria Aviation Oy',
                'Patria Land Services Oy',
                'Pikval Oy',
                'Pilkington Automotive Finland Oy',
                'Polar Electro Oy',
                'Ponsse Oyj',
                'Premec Oy',
                'Prolaser Oy',
                'Prysmian Cables and Systems Oy',
                'Purso Oy',
                'Pyhäsalmi Mine Oy',
                'Rautaruukki Oyj',
                'Raute Oyj',
                'Reka Kaapeli Oy',
                'REMU Oy',
                'Rettig Värme Ab',
                'Sacotec Components Oy',
                'Sahala Works',
                'SAH-KO Oy',
                'Sako Oy',
                'Salon Metalelektro Oy',
                'Sampo Hydraulics Oy',
                'Sampo-Rosenlew Oy',
                'Sandvik Mining and Construction Oy',
                'Sanmina-SCI EMS Haukipudas Oy',
                'Savonlinna Works Oy',
                'Scan-Cast Oy',
                'Scanfil EMS Oy',
                'SEW Industrial Gears Oy',
                'SKF Oy Ab, Muurame',
                'Solar Kaihdin Ky',
                'Stera Technologies Oy',
                'Steris Europe, Inc. Suomen sivuliike',
                'Sulzer Pumps Finland Oy',
                'Svanmet Oy',
                'Tarvasjoen Teräsovi Oy',
                'TEVO Oy',
                'TKM TTT Finland Oy',
                'Trafotek Oy',
                'Uudenkaupungin Rautavalimo Oy',
                'Vaahto Group Plc Oyj',
                'Vacon Oy',
                'Vaisala Oyj',
                'Valmet Automotive Oy',
                'Valmet Oyj',
                'Valonkone Oy',
                'Valtra Oy',
                'Wavin- Labko Oy',
                'Wipro Infrastructure Engineering Oy',
                'Wärtsilä Oyj',
                'YIT Oyj'
              ]
            },
            {
              smalltitle: 'Action plan for Industry - General',
            },
            {
              list: [
                'Betoniluoma Oy',
                'Betoni-Sampo Oy',
                'Cembrit Oy',
                'Finnair Facilities Management Oy',
                'Freudenberg Household Products Oy Ab',
                'Helprint Oy',
                'Icopal Oy',
                'Karjalan tekstiilipalvelu Oy',
                'Katepal Oy',
                'Lujabetoni Oy',
                'Länsi-Savo Oy',
                'Mittatehdas Oy',
                'Otavan Kirjapaino Oy',
                'PMK Värjäämö Oy',
                'PunaMusta Oy',
                'Päijät-Hämeen Tekstiilihuolto Oy',
                'Rakennusbetoni- ja Elementti Oy',
                'Recticel Oy',
                'Rudus Oy',
                'Sanoma Oyj',
                'SharpCell Oy',
                'Suur-Savon Sähkötyö Oy',
                'TS-Yhtymä Oy',
                'Tulikivi Oy',
                'Uusioaines Oy'
              ]
            },
            {
              smalltitle: 'Action Plan for Energy Production',
            },
            {
              list: [
                'Adven Oy',
                'Alholmens kraft Oy Ab',
                'Elenia Lämpö Oy',
                'Etelä-Savon Energia Oy',
                'Fortum Power and Heat Oy',
                'Helen Oy',
                'Jyväskylän Energia Oy',
                'Kanteleen Voima Oy',
                'Kemijoki Oy',
                'Keravan Energia Oy',
                'Kotkan Energia Oy',
                'KSS Energia Oy',
                'Kuopion Energia Oy',
                'Kurikan Kaukolämpö Oy',
                'Kymin Voima Oy',
                'Laanilan Voima Oy',
                'Lahti Energia Oy',
                'Lappeenrannan Lämpövoima Oy',
                'Leppäkosken Energia Oy',
                'Napapiirin Energia ja Vesi Oy',
                'Nokianvirran Energia Oy',
                'Oriveden Aluelämpö Oy',
                'Oulun Energia Oy',
                'Pohjois-Karjalan Sähkö Oy',
                'Pori Energia Oy',
                'Porin Prosessivoima Oy',
                'Porvoon Energia Oy - Borgå Energi Ab',
                'PVO-Lämpövoima Oy',
                'PVO-Vesivoima Oy',
                'Savon Voima Oyj',
                'Suur Savon Sähkö Oy',
                'Tampereen sähkölaitos',
                'Teollisuuden Voima Oyj',
                'Tornion Voima Oy',
                'Vantaan Energia Oy',
                'Vapo Oy',
                'Vaskiluodon Voima Oy',
                'Vattenfall Oy, Vesivoima',
                'Vieskan Voima Oy'
              ]
            },
            {
              smalltitle: 'Action Plan for Energy Services',
            },
            {
              list: [
                'Adven Oy',
                'Alajärven Lämpö Oy',
                'Caruna Espoo Distribution Oy',
                'Caruna Oy',
                'Ekenäs Energi Ab / Tammisaaren Energia Oy',
                'Elenia Lämpö Oy',
                'Elenia Oy',
                'Energiapolar Oy',
                'EPV Alueverkko Oy',
                'ESE-Verkko Oy',
                'Etelä-Savon Energia Oy',
                'Etelä-Suomen Energia Oy',
                'Fingrid Oyj',
                'Forssan Energia Oy',
                'Forssan Verkkopalvelut Oy',
                'Fortum Markets Oy',
                'Fortum Power and Heat Oy (Heat)',
                'Haminan Energia Oy',
                'Helen Oy',
                'Helen Sähköverkko Oy',
                'Hyvinkään lämpövoima Oy',
                'Imatran Seudun Sähkö Oy',
                'Imatran Seudun Sähkönsiirto Oy',
                'Inergia Oy',
                'JE-Siirto Oy',
                'Jyväskylän Energia Oy',
                'Jämsän Aluelämpö Oy',
                'Järvi-Suomen Energia Oy',
                'Karhu Voima Oy',
                'Kemin Energia Oy',
                'Keravan Energia Oy',
                'Keskusosuuskunta Oulun Seudun Sähkö',
                'Koillis-Satakunnan Sähkö Oy',
                'Kokemäen Sähkö Oy',
                'Kotkan Energia Oy',
                'KSS Energia Oy',
                'KSS Verkko Oy',
                'Kuopion Energia',
                'Kuopion Energia Oy',
                'Kymenlaakson Sähkö Oy',
                'Kymenlaakson Sähköverkko Oy',
                'Köyliön- Säkylän Sähkö Oy',
                'Lahti Energia Oy',
                'Laihian Nuuka Lämpö Oy',
                'Lappeenrannan Energia Oy',
                'Lempäälän Lämpö Oy',
                'Leppäkosken Energia Oy',
                'Leppäkosken Sähkö Oy',
                'LE-Sähköverkko Oy',
                'Loiste Energia Oy',
                'Loiste Lämpö Oy (ent. Kajaanin Lämpö Oy)',
                'Loiste Sähköverkko Oy',
                'Mäntsälän Sähkö Oy',
                'Napapiirin Energia ja Vesi Oy',
                'Nurmijärven Sähkö Oy',
                'Nurmijärven Sähköverkko Oy',
                'Otanmäen Lämpö Oy',
                'Oulun Energia Oy',
                'Oulun Energia Siirto ja Jakelu Oy',
                'Oulun sähkönmyynti Oy',
                'Paneliankosken Voima Oy',
                'Parikkalan Valo Oy',
                'PKS Sähkönsiirto Oy',
                'Pohjois-Karjalan Sähkö Oy',
                'Pori Energia Oy',
                'Pori Energia Sähköverkot Oy',
                'Porvoon Energia Oy - Borgå Energi Ab',
                'Porvoon Sähköverkko Oy',
                'Raahen Energia Oy',
                'Rauman Energia Oy',
                'Riihimäen Kaukolämpö Oy',
                'Rovakaira Oy',
                'Rovaniemen Verkko Oy',
                'Sallila Energia Oy',
                'Sallila Sähkönsiirto Oy',
                'Sastamalan Lämpö Oy',
                'Savon Voima Oyj',
                'Savon Voima Verkko Oy',
                'Suur Savon Sähkö Oy',
                'Switch Nordic Green AB Filial Finland',
                'Tampereen sähkölaitos',
                'Tampereen Sähköverkko Oy',
                'Tornion Energia Oy',
                'Tornionlaakson Sähkö Oy',
                'Turku Energia Oy - Åbo Energi Ab',
                'Turku Energia Sähköverkot Oy',
                'Vaasan Sähkö Oy',
                'Vaasan Sähkö Oy, kaukolämpöyksikkö',
                'Vaasan Sähköverkko Oy',
                'Vantaan Energia Oy',
                'Vantaan Energia Sähköverkot Oy',
                'Varkauden Aluelämpö Oy',
                'Vatajankosken Sähkö Oy',
                'Vattenfall Oy'
              ]
            },
            {
              smalltitle: 'Motor Trades and Repairs Sector Action Plan',
            },
            {
              list: [
                'Aro Yhtymä',
                'Auto-Kilta Oy',
                'Hämeen Autovaruste',
                'Kiinteistö Oy Lohikoskenkulma',
                'Kiinteistö Oy Lokomonkulma',
                'Kittilän Autopeltikorjaamo ja Maalaamo Oy',
                'Käyttöauto Oy',
                'O.K Auto Oy',
                'Pörhön Autoliike Oy',
                'Scania Suomi Oy',
                'Timosen Auto Oy',
                'Veho Group Oy Ab',
                'VV-Autotalo Oy ja Turun VV-Auto Oy'
              ]
            },
            {
              smalltitle: 'Commerce Sector Action Plan',
            },
            {
              list: [
                'Carlson Oy',
                'Hong Kong Import Oy Ltd',
                'Isojoen Konehalli Oy',
                'Jysk Oy',
                'Kesko Oyj',
                'Keuruun Megamarket Oy',
                'KWH Freeze Oy Ab',
                'Kärkkäinen Express Oy',
                'Lähdesmäki Oy Ilmajoki',
                'Motonet Oy',
                'Starkki Oy',
                'Stockmann Oy Ab/ Suomen tavaratalot',
                'Suomen Lähikauppa Oy',
                'Suomen Osuuskauppojen Keskuskunta',
                'Suomen Palvelutukkurit Oy',
                'Taloustalo Oy',
                'Tokmanni Oy',
                'TukkuHeino Oy',
                'Tuko Logistics Osuuskunta',
                'Variflex Oy',
                'Veljekset Keskinen Oy'
              ]
            },
            {
              smalltitle: 'Hotel and Restaurant Sector Action Plan',
            },
            {
              list: [
                'Citymac Travels Oy',
                'Deltarec Oy / Hiihtokeskus Sappee',
                'Gustavelund Oy',
                'Harriniva Oy',
                'Herrankukkaro Oy',
                'Hiihtokeskus Himosvuori Oy',
                'Hiihtokeskus Iso-Ylläs Oy',
                'Hotel Santa Claus Oy',
                'Hotelli Käenpesä',
                'Hotelli Luostotunturi Oy',
                'Hotelli Mesikämmen Oy',
                'Hotelli Rantakalla Oy',
                'Hotelliyhtymä Oy / Hotelli Helka',
                'Hullu Poro Oy',
                'Häkärinteet Oy',
                'Imatran kylpylä /Etelä-Karjalan Kuntoutumissäätiö',
                'Jepetron Oy',
                'Järjestötalo Oy / MaRa ry.',
                'Ka-Bir Oy',
                'Karjalohjan Päiväkumpu Oy',
                'Kiinteistö Oy Koutalaki 1',
                'Kuntoranta Oy',
                'Kuopion Kylpylä Oy',
                'Kymen Paviljonki Oy',
                'Kämp Group Oy',
                'Kätkä Viisi Oy',
                'Lasten Päivän Säätiö',
                'Levi Ski Resort Oy Ltd',
                'Levin Luontokeskus Oy',
                'Mattilanniemen Hotelli Oy',
                'Nemeko Oy/Scandic Oscar',
                'Park Marketing Oy / Park Hotel Turku',
                'Peurunka-konserni',
                'Pyhätunturi Oy',
                'Ravolta hotellit ja ravintolat Oy/ Next Hotel Rivoli Jardin',
                'Restel Oy',
                'Rukakeskus Oy',
                'Ryokan Oy',
                'Saarijärven Kylpylä Oy',
                'Saariselän tunturihotellit Oy',
                'Saija Oy',
                'Scandic Hotels Oy',
                'Scanredi Oy Ab',
                'StayAt Finland Oy',
                'ST-Ravintolat Oy',
                'Suomen Latu ry/ Suomen Latu Kiilopää',
                'Suomen Osuuskauppojen Keskuskunta',
                'Talma Ski Oy',
                'Tampereen Särkänniemi Oy',
                'Tykkimäen Vapaa-aikakeskus Oy',
                'Vuoristo-yhtiöt Oy',
                'Yyterin Kylpylähotelli Oy'
              ]
            },
            {
              smalltitle: 'Action Plan for Services – General',
            },
            {
              list: [
                'AEL Oy',
                'Betesda-säätiö',
                'Blue Lake Communications Oy',
                'DHL Supply Chain (Finland) Oy',
                'Eerikkilän Jalkapallohalli Oy',
                'Espoon Tennistuki ry',
                'Esport Arena Oy',
                'Europark Finland Oy',
                'Fastighets Ab Ekenäs Kungsgatan 7',
                'Fitness & Aerobic Club Oy',
                'Granlund Oy',
                'HAVI Logistics Oy',
                'Hämeenkyrön Jäähalli Oy',
                'Julius Tallberg-Kiinteistöt Oyj',
                'Jyväskylän Talouskouluyhdistys ry',
                'Karis Telefon Ab',
                'Kauppakeskus Itäkeskus Oy',
                'Kiinteistö Oy Honkahalli',
                'Kiinteistö Oy Kerttulan Jäähalli',
                'Kiinteistö Oy Tampereen Myllypuronkatu 30',
                'Kiinteistökomppania Oy',
                'Kiipulasäätiö',
                'Kuehne + Nagel Oy Ltd',
                'Kuusankosken Palloiluhalli Oy',
                'Lahden Jäähalli Oy',
                'Lauttasaaren Pienteollisuustalo Oy',
                'Limingan jäähalli Oy',
                'Loimijokilaakson Jäähalli Oy',
                'Mercator Oy Ab',
                'Myllypuron Tenniskeskus Oy',
                'Oulun Palloiluhallit Oy',
                'Oulun Sisustajat Oy',
                'Oy Julius Tallberg Ab',
                'Sipoon Jäähalli Oy - Sibbo Ishall Ab',
                'Suomen Messut Osuuskunta',
                'Tampereen Aikuiskoulutussäätiö / Aikuiskoulutuskeskus',
                'Tampereen ammattikorkeakoulu',
                'Tapiolan Monitoimiareena Oy',
                'Tuusulan Jäähalli Oy',
                'Työtehoseura ry',
                'Urjalan Jäähalli Oy',
                'Valtakunnallinen valmennus- ja liikuntakeskus Oy',
                'Veikkaus Oy'
              ]
            },
            {
              title: 'Property and Building Sector Energy Efficiency Agreement 2010–2016'
            },
            {
              smalltitle: 'Rental Property Action Plan',
            },
            {
              list: [
                'A-Kruunu Oy',
                'Asuntosäätiö',
                'Domus Arctica -säätiö',
                'Espoon Asunnot Oy',
                'Helsingin kaupungin asuinkiinteistöyhtiöt',
                'Helsingin seudun opiskelija-asuntosäätiö HOAS',
                'Jyväskylän Vuokra-asunnot Oy',
                'Jyväskylän yliopiston ylioppilaskunta',
                'Järvenpään Mestariasunnot Oy',
                'Keskinäinen eläkevakuutusyhtiö Ilmarinen',
                'Kiinteistö Oy Nikkarinkruunu',
                'Kiinteistö Oy Pikipruukki Fastighets Ab',
                'Kruunuasunnot Oy',
                'Lahden Talot Oy',
                'LähiTapiola Kiinteistövarainhoito Oy',
                'Mikalo Oy',
                'Niiralan Kulma Oy',
                'Sato Oyj',
                'Sivakka-yhtymä Oy',
                'Suomen Asumisoikeus Oy (Asokodit)',
                'Tampereen vuokratalosäätiö',
                'TVT Asunnot Oy',
                'Vaasan opiskelija-asuntosäätiö (VOAS)',
                'Varsinais-Suomen Asumisoikeus Oy',
                'VAV Asunnot Oy',
                'Vilusen Rinne Oy',
                'VVO-yhtymä Oy'
              ]
            },
            {
              smalltitle: 'Commercial Property Action Plan',
            },
            {
              list: [
                'Aalto Yliopistokiinteistöt Oy',
                'Aberdeen European Balanced Property Fund',
                'Aberdeen Property Fund Finland I Ky (APFF)',
                'Aberdeen Property Funds Sicav-Fis Pan Nordic',
                'Aberdeen Property Nordic Fund I Sicav',
                'Antilooppi Ky',
                'Citycon Oyj',
                'Cursor Oy',
                'Espoon Martinportti Oy',
                'Exilion Real Estate 1 Ky',
                'Genesta Property Nordic Finland Oy',
                'Helsingin Autotalo Oy',
                'Helsingin yliopiston ylioppilaskunta HYY',
                'Isku Invest Oy',
                'Jyväskylän Kassatalo Oy',
                'Kauppakeskus H-talo = Kiint. Oy Kuopion Haapaniemenkatu 20',
                'Kauppakeskuskiinteistöt FEA Ky',
                'Kerta Kiinteistöt Oy',
                'Keskinäinen Eläkevakuutusyhtiö Etera',
                'Keskinäinen eläkevakuutusyhtiö Ilmarinen',
                'Keskinäinen työeläkevakuutusyhtiö Varma',
                'Keva',
                'KI Oy Vantaan Rajatorpantie 8',
                'Kiinteistö Oy Kaarinantori',
                'Kiinteistö Oy Kangasalan Pikonlinna',
                'Kiinteistö Oy Koivulan Liikekeskus',
                'Kiinteistö Oy Kurssipesä',
                'Koy Alakortes',
                'Koy Kauppakeskus Sello',
                'Koy Malmin Asematie 6',
                'Logicor Oy',
                'Lyy-Invest Oy',
                'LähiTapiola Kiinteistövarainhoito Oy',
                'Niam Oy (Niam V HOP Holding Ab ja Niam V Two Star Holding Ab (Niam V)',
                'Nordea Henkivakuutus Suomi Oy',
                'Peimarin Koulutuskuntayhtymä',
                'Puolustushallinnon rakennuslaitos',
                'Raision Seurakunta',
                'Sagax Finland Oy',
                'Sampo Oyj',
                'Senaatti-kiinteistöt',
                'Sponda (Sponda Oyj ja Sponda Kiinteistöt Oy)',
                'Suomen Yliopistokiinteistöt Oy',
                'Technopolis Oyj',
                'Teollisuuskeskus Oy',
                'Valad Finland Oy',
                'Varisto Invest Oy',
                'Vioto Oy',
                'Vuokrakartio Oy',
              ]
            },
            {
              title: 'Energy efficiency agreement and energy programme for Finnish municipalities 2008-2016'
            },
            {
              smalltitle: 'Energy Efficiency Agreement 2008-2016',
            },
            {
              list: [
                'Akaa',
                'Espoo',
                'Eura',
                'Hamina',
                'Hankasalmi',
                'Heinola',
                'Helsinki',
                'Hyvinkää',
                'Ii',
                'Imatra',
                'Janakkala',
                'Joensuu',
                'Jyväskylä',
                'Järvenpää',
                'Kajaani',
                'Kangasala',
                'Kauniainen',
                'Kemi',
                'Kerava',
                'Kirkkonummi',
                'Kiuruvesi',
                'Kokkola',
                'Kotka',
                'Kouvola',
                'Kristiinankaupunki',
                'Kuopio',
                'Lahti',
                'Lappeenranta',
                'Laukaa',
                'Lempäälä',
                'Lieto',
                'Lieksa',
                'Lohja',
                'Mikkeli',
                'Mynämäki',
                'Mäntsälä',
                'Nokia',
                'Oulu',
                'Pieksämäki',
                'Pori',
                'Porvoo',
                'Raasepori',
                'Raisio',
                'Rauma',
                'Riihimäki',
                'Rovaniemi',
                'Saarijärvi',
                'Salo',
                'Sastamala',
                'Savonlinna',
                'Seinäjoki',
                'Siilinjärvi',
                'Siuntio',
                'Sodankylä',
                'Tampere',
                'Turku',
                'Tuusula',
                'Uusikaupunki',
                'Vaasa',
                'Valkeakoski',
                'Vantaa',
                'Varkaus',
                'Ylöjärvi',
                'Äänekoski',
                'Joint municipalities:',
                'Helsingin seudun ympäristöpalvelut kuntayhtymä',
                'HUS-kuntayhtymä',
                'Jyväskylän koulutuskuntayhtymä',
                'Kemi-Tornionlaakson koulutuskuntayhtymä',
                'Keski-Uudenmaan koulutuskuntayhtymä',
                'Kymenlaakson sairaanhoito- ja sosiaalipalvelujen kuntayhtymä, Carea',
                'Oulun seudun koulutuskuntayhtymä',
                'Pirkanmaan sairaanhoitopiirin kuntayhtymä',
                'Pohjois-Pohjanmaan sairaanhoitopiirin kuntayhtymä',
                'Pohjois-Savon Sairaanhoitopiirin kuntayhtymä',
                'Päijät-Hämeen koulutuskonserni -kuntayhtymä',
                'Rovaniemen koulutus-kuntayhtymä',
                'Vaasan sairaanhoitopiirin kuntayhtymä',
              ]
            },
            {
              smalltitle: 'Energy Programme 2008-2016',
            },
            {
              list: [
                'Alavuus',
                'Asikkala',
                'Haukipudas',
                'Iitti',
                'Ilmajoki',
                'Ilomantsi',
                'Inari',
                'Inkoo',
                'Isojoki',
                'Jalasjärvi',
                'Jokioinen',
                'Jämsä',
                'Kalajoki',
                'Karkkila',
                'Kauhajoki',
                'Kemijärvi',
                'Kerimäki',
                'Kuhmoinen',
                'Kuortane',
                'Kurikka',
                'Kuusamo',
                'Laihia',
                'Laitila',
                'Lapua',
                'Leppävirta',
                'Lestijärvi',
                'Liminka',
                'Loviisa',
                'Muhos',
                'Nurmes',
                'Närpiö',
                'Orimattila',
                'Orivesi',
                'Padasjoki',
                'Parikkala',
                'Pelkosenniemi',
                'Pietarsaari',
                'Pirkkala',
                'Pudasjärvi',
                'Pyhäranta',
                'Ranua',
                'Rautjärvi',
                'Ristiina',
                'Sievi',
                'Simo',
                'Sipoo',
                'Taivalkoski',
                'Teuvan kunta',
                'Toholampi',
                'Toivakka',
                'Urjala',
                'Uurainen',
                'Valtimo',
                'Veteli',
                'Virrat',
                'Mikkelin Ammattikorkeakoulu Oy',
                'Ylä-Savon SOTE kuntayhtymä'
              ]
            },
            {
              smalltitle: 'Energy Efficiency Agreement for Heating oils and transportation fuels 2008-2016, HÖYLÄ III'
            },
            {
              list: [
                'Neste Markkinointi Oy',
                'Oy Shell Ab',
                'St1 Oy',
                'Suomalainen Energiaosuuskunta (SEO)',
                'Suomen Osuuskauppojen Keskuskunta',
                'Oy Teboil Ab'
              ]
            }
          ];
        break;
      default:
        this.router.navigateByUrl('/etusivu');
      }
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

}



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/page/page.component.ts